<template>
  <div
    :class="`row home-row ${
      selected_ids.length > 0 ? 'selected-properties' : ''
    }`"
  >
    <div v-if="!apiparams.nearby" id="filter-explore-btn">
      <button @click="getLocation" class="filter-explore-nearby-btn">
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5 0C5.1589 0 0 5.1589 0 11.5C0 17.8411 5.1589 23 11.5 23C15.0647 23 18.3695 21.3871 20.5669 18.5748C20.726 18.3712 20.6899 18.077 20.4862 17.9179C20.2824 17.7586 19.9883 17.7948 19.8292 17.9985C17.8104 20.5821 14.7745 22.064 11.5 22.064C5.67507 22.064 0.936095 17.325 0.936095 11.5C0.936095 5.675 5.67507 0.936095 11.5 0.936095C17.3249 0.936095 22.0639 5.67507 22.0639 11.5C22.0639 11.7584 22.2735 11.968 22.532 11.968C22.7904 11.968 23 11.7584 23 11.5C23.0001 5.1589 17.8412 0 11.5 0Z"
            fill="#FD0707"
          />
          <path
            d="M11.3105 18.6361C11.3412 18.6422 11.3718 18.6451 11.402 18.6451C11.5882 18.6451 11.7607 18.5336 11.8343 18.3561L16.7672 6.44696C16.8396 6.27207 16.7995 6.07073 16.6657 5.93687C16.5318 5.80301 16.3306 5.76307 16.1556 5.83538L4.24652 10.7684C4.04019 10.8539 3.92302 11.0731 3.96655 11.2921C4.01016 11.5112 4.20229 11.6689 4.42563 11.6689H10.9338V18.1771C10.9338 18.4003 11.0916 18.5925 11.3105 18.6361ZM6.77865 10.7327L15.4699 7.13265L11.8698 15.824V11.2008C11.8698 10.9423 11.6602 10.7327 11.4018 10.7327H6.77865Z"
            fill="#FD0707"
          />
        </svg>
        <span class="ml-2">Explore Nearby</span>
      </button>
    </div>

    <!-- Desktop Filter Column -->
    <div class="col-lg-3 m-0 pr-0 pb-4 side-gadgets stick-top db-mn">
      <div
        v-if="!apiparams.nearby"
        class="position-relative filter-nearby-redbox px-4 mb-4"
      >
        <div
          class="position-absolute"
          style="left: 15px; top: -20px; z-index: 0"
        >
          <img src="/imgs/location-d.svg" alt="shijie-location" />
        </div>
        <div
          style="max-width: 170px; z-index: 1"
          class="d-flex flex-column justify-content-center ml-auto position-relative"
        >
          <div class="filter-explore-text text-center">
            Discover Properties around you (5 KM)
          </div>
          <button @click="getLocation" class="filter-explore-nearby-btn">
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 0C5.1589 0 0 5.1589 0 11.5C0 17.8411 5.1589 23 11.5 23C15.0647 23 18.3695 21.3871 20.5669 18.5748C20.726 18.3712 20.6899 18.077 20.4862 17.9179C20.2824 17.7586 19.9883 17.7948 19.8292 17.9985C17.8104 20.5821 14.7745 22.064 11.5 22.064C5.67507 22.064 0.936095 17.325 0.936095 11.5C0.936095 5.675 5.67507 0.936095 11.5 0.936095C17.3249 0.936095 22.0639 5.67507 22.0639 11.5C22.0639 11.7584 22.2735 11.968 22.532 11.968C22.7904 11.968 23 11.7584 23 11.5C23.0001 5.1589 17.8412 0 11.5 0Z"
                fill="#FD0707"
              />
              <path
                d="M11.3105 18.6361C11.3412 18.6422 11.3718 18.6451 11.402 18.6451C11.5882 18.6451 11.7607 18.5336 11.8343 18.3561L16.7672 6.44696C16.8396 6.27207 16.7995 6.07073 16.6657 5.93687C16.5318 5.80301 16.3306 5.76307 16.1556 5.83538L4.24652 10.7684C4.04019 10.8539 3.92302 11.0731 3.96655 11.2921C4.01016 11.5112 4.20229 11.6689 4.42563 11.6689H10.9338V18.1771C10.9338 18.4003 11.0916 18.5925 11.3105 18.6361ZM6.77865 10.7327L15.4699 7.13265L11.8698 15.824V11.2008C11.8698 10.9423 11.6602 10.7327 11.4018 10.7327H6.77865Z"
                fill="#FD0707"
              />
            </svg>
            <span class="ml-2">Explore Nearby</span>
          </button>
        </div>
      </div>

      <!-- listing type -->
      <div class="filter-card" style="margin-top: 10px">
        <div class="d-flex align-items-center p-3">
          <div class="mr-auto">Listing Type</div>
          <button
            class="card-btn collapsed"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.16811 12L6.16811 0L7.31618 4.7685e-08L7.31618 12H6.16811Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.427734 5.45454L13.0566 5.45455V6.54545L0.427734 6.54545L0.427734 5.45454Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        <div
          id="collapseOne"
          class="border-t collapse show p-3"
          aria-labelledby="listingType"
        >
          <div class="row justify-content-center" style="margin: 0 -5px">
            <label
              class="btn sale-checkbox-label"
              :class="{ active: apiparams.listing_type == 'SALE' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('listing_type', $event)"
                value="SALE"
              />
              Sale
            </label>
            <label
              class="btn sale-checkbox-label"
              :class="{ active: apiparams.listing_type == 'RENT' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('listing_type', $event)"
                value="RENT"
              />
              Rent
            </label>
            <label
              class="btn sale-checkbox-label"
              :class="{ active: apiparams.listing_type == 'AUCTION' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('listing_type', $event)"
                value="AUCTION"
              />
              Auction
            </label>
          </div>
        </div>
      </div>

      <!-- listing type -->
      <div class="filter-card" style="margin-top: 10px">
        <div class="d-flex align-items-center p-3">
          <div class="mr-auto">
            How much is your property selling price or rental rate ? Check our
            recently transacted property selling price and rental rate now
          </div>
          <button
            class="card-btn collapsed"
            data-toggle="collapse"
            data-target="#collapseSearchMode"
            aria-expanded="true"
            aria-controls="collapseSearchMode"
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.16811 12L6.16811 0L7.31618 4.7685e-08L7.31618 12H6.16811Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.427734 5.45454L13.0566 5.45455V6.54545L0.427734 6.54545L0.427734 5.45454Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        <div
          id="collapseSearchMode"
          class="border-t collapse show p-3"
          aria-labelledby="searchMode"
        >
          <div class="row justify-content-center" style="margin: 0 -5px">
            <label
              class="btn sale-checkbox-label half"
              :class="{
                active: search_mode == 'listing',
              }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('search_mode', $event)"
                value="listing"
              />
              Listing
            </label>
            <label
              class="btn sale-checkbox-label half"
              :class="{ active: search_mode == 'transaction' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('search_mode', $event)"
                value="transaction"
              />
              Transaction
            </label>
            <!-- <label
              class="btn sale-checkbox-label"
              :class="{ active: apiparams.search_mode == 'mixed' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('search_mode', $event)"
                value="mixed"
              />
              Mixed
            </label> -->
          </div>
        </div>
      </div>

      <!-- Property Category -->
      <div class="filter-card">
        <div class="d-flex align-items-center p-3">
          <div class="mr-auto">Property Categories</div>
          <button
            class="card-btn collapsed"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.16811 12L6.16811 0L7.31618 4.7685e-08L7.31618 12H6.16811Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.427734 5.45454L13.0566 5.45455V6.54545L0.427734 6.54545L0.427734 5.45454Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div
          id="collapseTwo"
          class="border-t collapse show p-3"
          aria-labelledby="propertyCategory"
        >
          <label class="prop-radio-label-d">
            <input
              type="radio"
              @click="updateParam('category', $event)"
              value="RESIDENTIAL"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{ lactive: apiparams.category == 'RESIDENTIAL' }"
            ></span>
            Residential
          </label>
          <label class="prop-radio-label-d">
            <input
              type="radio"
              @click="updateParam('category', $event)"
              value="COMMERCIAL"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{ lactive: apiparams.category == 'COMMERCIAL' }"
            ></span>
            Commercial
          </label>
          <label class="prop-radio-label-d">
            <input
              type="radio"
              @click="updateParam('category', $event)"
              value="INDUSTRIAL"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{ lactive: apiparams.category == 'INDUSTRIAL' }"
            ></span>
            Industrial
          </label>
          <label class="prop-radio-label-d">
            <input
              type="radio"
              @click="updateParam('category', $event)"
              value="LAND"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{ lactive: apiparams.category == 'LAND' }"
            ></span>
            Land
          </label>
        </div>
      </div>

      <!-- Property types -->
      <div class="filter-card">
        <div class="d-flex align-items-center p-3">
          <div class="mr-auto">Property Types</div>
          <button
            class="card-btn collapsed"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.16811 12L6.16811 0L7.31618 4.7685e-08L7.31618 12H6.16811Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.427734 5.45454L13.0566 5.45455V6.54545L0.427734 6.54545L0.427734 5.45454Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div
          id="collapseThree"
          class="border-t collapse show p-3"
          aria-labelledby="propertyType"
        >
          <div class="general-heading-2 font-weight-normal my-3">Landed</div>
          <label class="prop-radio-label-d">
            <input
              type="checkbox"
              @click="updateParam('prop_type_landed', $event)"
              value="TERRACE"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{
                lactive: apiparams.property_type_subtype.includes('TERRACE'),
              }"
            ></span>
            Terrace
          </label>
          <label class="prop-radio-label-d">
            <input
              type="checkbox"
              @click="updateParam('prop_type_landed', $event)"
              value="SEMI DETACHED"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{
                lactive:
                  apiparams.property_type_subtype.includes('SEMI DETACHED'),
              }"
            ></span>
            Semi Detached
          </label>
          <label class="prop-radio-label-d">
            <input
              type="checkbox"
              @click="updateParam('prop_type_landed', $event)"
              value="DETACHED"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{
                lactive: apiparams.property_type_subtype.includes('DETACHED'),
              }"
            ></span>
            Detached
          </label>

          <div class="general-heading-2 font-weight-normal my-3">Highrise</div>
          <label class="prop-radio-label-d">
            <input
              type="radio"
              @click="updateParam('prop_type_highrise', $event)"
              value="DETACHED"
            />
            <span
              class="prop-radio-label-d-before"
              :class="{ lactive: apiparams.property_type_group == 'HIGHRISE' }"
            ></span>
            All Highrise
          </label>
        </div>
      </div>

      <!-- Pricing -->
      <div class="filter-card">
        <div class="d-flex align-items-center p-3">
          <div class="mr-auto">Pricing</div>
          <button
            class="card-btn collapsed"
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="false"
            aria-controls="collapseFour"
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.16811 12L6.16811 0L7.31618 4.7685e-08L7.31618 12H6.16811Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.427734 5.45454L13.0566 5.45455V6.54545L0.427734 6.54545L0.427734 5.45454Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div
          id="collapseFour"
          class="border-t collapse show p-3"
          aria-labelledby="propertyPrice"
        >
          <div class="d-flex flex-column mt-3">
            <div class="pb-3 general-text-1">Minimum</div>
            <div class="filter-price-wrapper">
              <span class="filter-price-rm">RM</span>
              <input
                type="number"
                v-model="minprice"
                class="filter-price-range"
                placeholder="E.g 5,000"
              />
            </div>
          </div>
          <div class="d-flex flex-column mt-3">
            <div class="pb-3 general-text-1">Maximum</div>
            <div class="filter-price-wrapper">
              <span class="filter-price-rm">RM</span>
              <input
                type="number"
                v-model="maxprice"
                class="filter-price-range"
                placeholder="E.g 10,000"
              />
            </div>
          </div>
          <button
            @click="updateParam('price')"
            class="mt-4 filter-apply-btn-wide"
          >
            Filter Pricing
          </button>
        </div>
      </div>

      <div class="filter-card" style="margin-top: 10px">
        <div class="align-items-center p-3">
          <div class="mr-auto mb-2 font-bold" style="font-size: 16px;"><b>Trusted Real Estate Agent in Penang & Across Malaysia</b></div>
          <div class="mr-auto mb-2">Navigating the property market requires more than just listings—it demands expertise, integrity, and a deep understanding of local dynamics. As a <b>real estate agent in Penang</b>, our role goes beyond transactions. We offer tailored insights, backed by years of industry experience, to help clients make confident decisions—whether buying, selling, or investing.</div>
          <div class="mr-auto mb-2">What sets a reputable <b><a href="/about-us">commercial real estate agent</a> in Malaysia</b> apart is the ability to align clients' goals with strategic opportunities. From urban condominiums in George Town to luxury bungalows in Mont Kiara, we deliver personalised service that reflects deep market knowledge and ethical practice. Our guidance is built on trust, transparency, and consistent performance—key elements that define long-term success in this competitive industry.</div>
          <div class="mr-auto mb-2">With a proven track record and a client-first approach, we ensure every step of the property journey is clear and rewarding. Whether you're a first-time buyer or a seasoned investor, you're not just getting a service—you’re gaining a partner who values your aspirations.</div>
          <div class="mr-auto">Looking to make your next property move count? <a href="/general-enquiries">Let’s talk</a>—your trusted real estate ally is just a click away.</div>
        </div>
      </div>
    </div>

    <!-- Mobile Filter Column -->
    <div id="menubar" class="side-gadgets">
      <div
        class="dn-mf align-items-center justify-content-between filter-div m-0"
      >
        <button @click="closeNav()" class="popup-back-btn">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="d-flex align-items-center">
          <div
            class="d-flex align-items-center justify-content-center mr-2"
            style="
              color: #ffffff;
              border-radius: 50%;
              height: 30px;
              width: 30px;
              border: 1px solid #ffffff;
              background: #282a2a;
            "
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 11 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.18182 8.22222V5.41358M2.18182 3.80864V1M5.33333 8.22222V4.61111M5.33333 3.00617V1M8.48485 8.22222V6.21605M8.48485 4.61111V1M1 5.41358H3.36364M4.15152 3.00617H6.51515M7.30303 6.21605H9.66667"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span class="font-weight-bold">More Filter</span>
        </div>
        <button
          @click="
            resetFilter();
            closeNav();
          "
          class="red-text-btn"
        >
          Reset
        </button>
      </div>
      <div
        class="general-heading-2 mr-auto dn-mb filter-div mb-0 pb-0"
        v-if="!error"
        style="min-height: 60px"
      >
        <span class="text-capitalize" v-if="searchText">
          {{ searchText.toLowerCase() }}
        </span>
        <span v-if="enteredText">
          Containing
          <span>"{{ enteredText }}"</span>
        </span>
      </div>
      <div
        class="general-heading-2 mr-auto dn-mb pt-4 px-4"
        v-else
        style="min-height: 60px"
      >
        No Match Found
      </div>

      <!-- Mobile transactions picker -->
      <!-- listing type -->
      <div class="filter-card" style="margin-top: 10px">
        <div class="d-flex align-items-center p-3">
          <div class="mr-auto">
            How much is your property selling price or rental rate ? Check our
            recently transacted property selling price and rental rate now
          </div>
        </div>

        <div
          id="collapseSearchMode"
          class="border-t collapse show p-3"
          aria-labelledby="searchMode"
        >
          <div class="row justify-content-center" style="margin: 0 -5px">
            <label
              class="btn sale-checkbox-label half"
              :class="{
                active: search_mode == 'listing',
              }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('search_mode', $event)"
                value="listing"
              />
              Listing
            </label>
            <label
              class="btn sale-checkbox-label half"
              :class="{ active: search_mode == 'transaction' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('search_mode', $event)"
                value="transaction"
              />
              Transaction
            </label>
            <!-- <label
              class="btn sale-checkbox-label"
              :class="{ active: apiparams.search_mode == 'mixed' }"
            >
              <input
                type="radio"
                class="sale-checkbox-input"
                @click="updateParam('search_mode', $event)"
                value="mixed"
              />
              Mixed
            </label> -->
          </div>
        </div>
      </div>

      <!-- Property types -->
      <div class="filter-div">
        <div class="dn-mf align-items-center justify-content-between mt-3">
          <span style="color: #777777">Filter by Property Types</span>
          <button
            @click="updateParam('prop_type_reset', '')"
            class="red-text-btn"
          >
            Select All
          </button>
        </div>
        <div class="df-mn align-items-center justify-content-between">
          <div class="general-red-subheading">Property Types</div>
          <button
            @click="updateParam('prop_type_reset', '')"
            class="red-text-btn"
          >
            Select All
          </button>
        </div>

        <div class="general-heading-2 font-weight-normal my-3">Landed</div>
        <label class="btn proptypes-checkbox-label">
          <input
            type="checkbox"
            @click="updateParam('prop_type_landed', $event)"
            value="TERRACE"
          />
          <span
            class="proptypes-checkbox-label-before"
            :class="{
              lactive:
                apiparams.property_type_subtype.includes('TERRACE') ||
                proptype_all,
            }"
          >
            <svg
              v-if="apiparams.property_type_subtype.includes('TERRACE')"
              width="10"
              height="8"
              viewBox="0 0 9 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.66667 1L3.08333 6L1 3.72727"
                stroke="#F7F7FC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          Terrace
        </label>
        <label class="btn proptypes-checkbox-label">
          <input
            type="checkbox"
            @click="updateParam('prop_type_landed', $event)"
            value="SEMI DETACHED"
          />
          <span
            class="proptypes-checkbox-label-before"
            :class="{
              lactive:
                apiparams.property_type_subtype.includes('SEMI DETACHED') ||
                proptype_all,
            }"
          >
            <svg
              v-if="apiparams.property_type_subtype.includes('SEMI DETACHED')"
              width="10"
              height="8"
              viewBox="0 0 9 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.66667 1L3.08333 6L1 3.72727"
                stroke="#F7F7FC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          Semi Detached
        </label>
        <label class="btn proptypes-checkbox-label">
          <input
            type="checkbox"
            @click="updateParam('prop_type_landed', $event)"
            value="DETACHED"
          />
          <span
            class="proptypes-checkbox-label-before"
            :class="{
              lactive:
                apiparams.property_type_subtype.includes('DETACHED') ||
                proptype_all,
            }"
          >
            <svg
              v-if="apiparams.property_type_subtype.includes('DETACHED')"
              width="10"
              height="8"
              viewBox="0 0 9 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.66667 1L3.08333 6L1 3.72727"
                stroke="#F7F7FC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          Detached
        </label>

        <div class="general-heading-2 font-weight-normal my-3">Highrise</div>
        <label class="btn proptypes-checkbox-label">
          <input
            type="checkbox"
            @click="updateParam('prop_type_highrise', $event)"
            value="DETACHED"
          />
          <span
            class="proptypes-checkbox-label-before"
            :class="{
              lactive:
                apiparams.property_type_group == 'HIGHRISE' || proptype_all,
            }"
          >
            <svg
              v-if="apiparams.property_type_group == 'HIGHRISE'"
              width="10"
              height="8"
              viewBox="0 0 9 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.66667 1L3.08333 6L1 3.72727"
                stroke="#F7F7FC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          All Highrise
        </label>
      </div>

      <!-- Pricing -->
      <div class="filter-div small-text">
        <div class="dn-mb" style="color: #777777">Filter by Property Price</div>
        <div class="general-red-subheading db-mn">Pricing</div>
        <div class="d-flex flex-column mt-4">
          <div class="pb-3 general-text-1">Minimum</div>
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input
              type="number"
              @input="updateParam('min_price', $event)"
              class="filter-price-range"
              placeholder="E.g 5,000"
            />
          </div>
        </div>
        <div class="d-flex flex-column mt-4">
          <div class="pb-3 general-text-1">Maximum</div>
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input
              type="number"
              @input="updateParam('max_price', $event)"
              class="filter-price-range"
              placeholder="E.g 10,000"
            />
          </div>
        </div>
      </div>

      <div class="filter-card" style="margin-top: 10px">
        <div class="align-items-center p-3">
          <div class="mr-auto mb-2 font-bold" style="font-size: 16px;"><b>Trusted Real Estate Agent in Penang & Across Malaysia</b></div>
          <div class="mr-auto mb-2">Navigating the property market requires more than just listings—it demands expertise, integrity, and a deep understanding of local dynamics. As a <b>real estate agent in Penang</b>, our role goes beyond transactions. We offer tailored insights, backed by years of industry experience, to help clients make confident decisions—whether buying, selling, or investing.</div>
          <div class="mr-auto mb-2">What sets a reputable <b><a href="/about-us">commercial real estate agent</a> in Malaysia</b> apart is the ability to align clients' goals with strategic opportunities. From urban condominiums in George Town to luxury bungalows in Mont Kiara, we deliver personalised service that reflects deep market knowledge and ethical practice. Our guidance is built on trust, transparency, and consistent performance—key elements that define long-term success in this competitive industry.</div>
          <div class="mr-auto mb-2">With a proven track record and a client-first approach, we ensure every step of the property journey is clear and rewarding. Whether you're a first-time buyer or a seasoned investor, you're not just getting a service—you’re gaining a partner who values your aspirations.</div>
          <div class="mr-auto">Looking to make your next property move count? <a href="/general-enquiries">Let’s talk</a>—your trusted real estate ally is just a click away.</div>
        </div>
      </div>

      <!-- bottom buttons -->
      <!-- <div
        id="show-property"
        class="filter-div m-0 justify-content-center d-flex position-fixed w-100"
      >
        <button @click="closeNav()" class="btn filter-apply-btn">
          Show Properties
        </button>
      </div> -->
    </div>

    <!-- Main Column -->
    <div class="col-lg-9 p-0">
      <div class="main-col">
        <!-- Desktop location filter -->
        <div class="stick-top db-mn desktop-loc">
          <div v-if="isloaded" class="pt-3 pb-4">
            <div
              style="
                font-size: 22px;
                display: flex;
                justify-content: space-between;
              "
              v-if="!error"
            >
              <!-- title with search listing  -->
              <!-- <div>
                <span class="text-capitalize" v-if="searchText">
                  {{ searchText.toLowerCase() }}
                </span>
                <span v-if="enteredText">
                  Containing
                  <span>"{{ enteredText }}"</span>
                </span>
              </div> -->

              <div>
                Trusted Real Estate Agent in Penang & Across Malaysia
              </div>

              <span style="font-size: 16px"
                >{{ resultnum }}
                {{
                  search_mode == "listing" ? "listings" : "transactions"
                }}</span
              >
            </div>
            <div v-else style="font-size: 22px">No Match Found</div>
          </div>
          <div v-else class="py-4">
            <span style="font-size: 22px">Searching...</span>
          </div>

          <div class="d-flex align-items-center">
            <button
              class="my-2 mr-2 filter-location filter-select-icon text-capitalize text-left"
              data-toggle="modal"
              data-target="#area-select"
              style="padding-right: 50px"
            >
              <span v-if="apiparams.state" class="text-capitalize">{{
                apiparams.state.toLowerCase()
              }}</span>
              <span v-if="apiparams.state && apiparams.area">, </span>
              <span v-if="apiparams.area" class="text-capitalize">{{
                apiparams.area.toLowerCase()
              }}</span>
              <span v-if="!apiparams.state && !apiparams.area">
                <svg
                  width="25"
                  height="23"
                  viewBox="0 0 30 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.5858 12.5356C20.5858 11.8505 20.4486 11.1721 20.1819 10.5392C19.9152 9.90626 19.5243 9.33117 19.0315 8.84675C18.5387 8.36232 17.9536 7.97806 17.3098 7.71589C16.6659 7.45372 15.9758 7.31879 15.2789 7.31879C14.582 7.31879 13.8919 7.45372 13.248 7.71589C12.6042 7.97806 12.0191 8.36232 11.5263 8.84675C11.0335 9.33117 10.6426 9.90626 10.3759 10.5392C10.1092 11.1721 9.97196 11.8505 9.97196 12.5356C9.97196 13.5692 10.2828 14.5306 10.8097 15.3415H10.8036C12.5928 18.0952 15.2789 22.2239 15.2789 22.2239L19.7542 15.3415H19.7489C20.295 14.5041 20.5855 13.5303 20.5858 12.5356ZM15.2789 14.7713C14.6757 14.7713 14.0972 14.5358 13.6707 14.1165C13.2441 13.6972 13.0045 13.1285 13.0045 12.5356C13.0045 11.9426 13.2441 11.3739 13.6707 10.9546C14.0972 10.5354 14.6757 10.2998 15.2789 10.2998C15.8821 10.2998 16.4606 10.5354 16.8871 10.9546C17.3137 11.3739 17.5533 11.9426 17.5533 12.5356C17.5533 13.1285 17.3137 13.6972 16.8871 14.1165C16.4606 14.5358 15.8821 14.7713 15.2789 14.7713Z"
                    fill="white"
                  />
                  <path
                    d="M28.3747 10.003C25.8243 2.83315 17.7495 -0.982679 10.3747 1.49687C2.99991 3.97643 -0.924997 11.8268 1.62544 18.9966C3.05919 23.0272 6.26418 26.1332 10.4187 27.5181C10.7196 27.6184 11.0472 27.4625 11.1503 27.17C11.2535 26.8773 11.0932 26.5589 10.7923 26.4587C6.97553 25.1863 4.03108 22.3331 2.71404 18.6306C0.371213 12.0444 3.97665 4.83305 10.7512 2.55531C17.5257 0.277563 24.9432 3.78283 27.286 10.369C29.6288 16.9552 26.0234 24.1666 19.2489 26.4443C18.9484 26.5454 18.7889 26.8643 18.8928 27.1565C18.9968 27.4487 19.3249 27.6038 19.6254 27.5027C27.0002 25.0233 30.9252 17.1729 28.3747 10.003Z"
                    fill="white"
                  />
                </svg>
                <span class="pl-2">All Locations</span>
              </span>
            </button>
            <!-- <select class="m-2 filter-location filter-select-icon text-capitalize" v-model="cur_state" id="filter-state">
                            <option style="display:none" value="State">
                                <svg width="28" height="26" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.5858 12.5356C20.5858 11.8505 20.4486 11.1721 20.1819 10.5392C19.9152 9.90626 19.5243 9.33117 19.0315 8.84675C18.5387 8.36232 17.9536 7.97806 17.3098 7.71589C16.6659 7.45372 15.9758 7.31879 15.2789 7.31879C14.582 7.31879 13.8919 7.45372 13.248 7.71589C12.6042 7.97806 12.0191 8.36232 11.5263 8.84675C11.0335 9.33117 10.6426 9.90626 10.3759 10.5392C10.1092 11.1721 9.97196 11.8505 9.97196 12.5356C9.97196 13.5692 10.2828 14.5306 10.8097 15.3415H10.8036C12.5928 18.0952 15.2789 22.2239 15.2789 22.2239L19.7542 15.3415H19.7489C20.295 14.5041 20.5855 13.5303 20.5858 12.5356ZM15.2789 14.7713C14.6757 14.7713 14.0972 14.5358 13.6707 14.1165C13.2441 13.6972 13.0045 13.1285 13.0045 12.5356C13.0045 11.9426 13.2441 11.3739 13.6707 10.9546C14.0972 10.5354 14.6757 10.2998 15.2789 10.2998C15.8821 10.2998 16.4606 10.5354 16.8871 10.9546C17.3137 11.3739 17.5533 11.9426 17.5533 12.5356C17.5533 13.1285 17.3137 13.6972 16.8871 14.1165C16.4606 14.5358 15.8821 14.7713 15.2789 14.7713Z" fill="white"/>
                                    <path d="M28.3747 10.003C25.8243 2.83315 17.7495 -0.982679 10.3747 1.49687C2.99991 3.97643 -0.924997 11.8268 1.62544 18.9966C3.05919 23.0272 6.26418 26.1332 10.4187 27.5181C10.7196 27.6184 11.0472 27.4625 11.1503 27.17C11.2535 26.8773 11.0932 26.5589 10.7923 26.4587C6.97553 25.1863 4.03108 22.3331 2.71404 18.6306C0.371213 12.0444 3.97665 4.83305 10.7512 2.55531C17.5257 0.277563 24.9432 3.78283 27.286 10.369C29.6288 16.9552 26.0234 24.1666 19.2489 26.4443C18.9484 26.5454 18.7889 26.8643 18.8928 27.1565C18.9968 27.4487 19.3249 27.6038 19.6254 27.5027C27.0002 25.0233 30.9252 17.1729 28.3747 10.003Z" fill="white"/>
                                </svg>
                                All States
                            </option>
                            <option v-for="option in states" class="text-capitalize" :key="option.index" :value="option">
                                {{ option.toLowerCase() }}
                            </option>
                        </select>
                        <select class="m-2 filter-location filter-select-icon text-capitalize" v-model="cur_area" id="filter-area">
                            <option style="display:none;" value="Area">
                                <svg width="28" height="26" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.5858 12.5356C20.5858 11.8505 20.4486 11.1721 20.1819 10.5392C19.9152 9.90626 19.5243 9.33117 19.0315 8.84675C18.5387 8.36232 17.9536 7.97806 17.3098 7.71589C16.6659 7.45372 15.9758 7.31879 15.2789 7.31879C14.582 7.31879 13.8919 7.45372 13.248 7.71589C12.6042 7.97806 12.0191 8.36232 11.5263 8.84675C11.0335 9.33117 10.6426 9.90626 10.3759 10.5392C10.1092 11.1721 9.97196 11.8505 9.97196 12.5356C9.97196 13.5692 10.2828 14.5306 10.8097 15.3415H10.8036C12.5928 18.0952 15.2789 22.2239 15.2789 22.2239L19.7542 15.3415H19.7489C20.295 14.5041 20.5855 13.5303 20.5858 12.5356ZM15.2789 14.7713C14.6757 14.7713 14.0972 14.5358 13.6707 14.1165C13.2441 13.6972 13.0045 13.1285 13.0045 12.5356C13.0045 11.9426 13.2441 11.3739 13.6707 10.9546C14.0972 10.5354 14.6757 10.2998 15.2789 10.2998C15.8821 10.2998 16.4606 10.5354 16.8871 10.9546C17.3137 11.3739 17.5533 11.9426 17.5533 12.5356C17.5533 13.1285 17.3137 13.6972 16.8871 14.1165C16.4606 14.5358 15.8821 14.7713 15.2789 14.7713Z" fill="white"/>
                                    <path d="M28.3747 10.003C25.8243 2.83315 17.7495 -0.982679 10.3747 1.49687C2.99991 3.97643 -0.924997 11.8268 1.62544 18.9966C3.05919 23.0272 6.26418 26.1332 10.4187 27.5181C10.7196 27.6184 11.0472 27.4625 11.1503 27.17C11.2535 26.8773 11.0932 26.5589 10.7923 26.4587C6.97553 25.1863 4.03108 22.3331 2.71404 18.6306C0.371213 12.0444 3.97665 4.83305 10.7512 2.55531C17.5257 0.277563 24.9432 3.78283 27.286 10.369C29.6288 16.9552 26.0234 24.1666 19.2489 26.4443C18.9484 26.5454 18.7889 26.8643 18.8928 27.1565C18.9968 27.4487 19.3249 27.6038 19.6254 27.5027C27.0002 25.0233 30.9252 17.1729 28.3747 10.003Z" fill="white"/>
                                </svg>
                                All Areas
                            </option>
                            <option v-for="option in areas" class="text-capitalize" :key="option.index" :value="option">
                                {{ option.toLowerCase() }}
                            </option>
                        </select> -->
            <button
              @click="getLocation"
              id="nearby-btn"
              class="my-2 ml-2 mr-3"
              :class="{ active: apiparams.nearby }"
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5 0C5.1589 0 0 5.1589 0 11.5C0 17.8411 5.1589 23 11.5 23C15.0647 23 18.3695 21.3871 20.5669 18.5748C20.726 18.3712 20.6899 18.077 20.4862 17.9179C20.2824 17.7586 19.9883 17.7948 19.8292 17.9985C17.8104 20.5821 14.7745 22.064 11.5 22.064C5.67507 22.064 0.936095 17.325 0.936095 11.5C0.936095 5.675 5.67507 0.936095 11.5 0.936095C17.3249 0.936095 22.0639 5.67507 22.0639 11.5C22.0639 11.7584 22.2735 11.968 22.532 11.968C22.7904 11.968 23 11.7584 23 11.5C23.0001 5.1589 17.8412 0 11.5 0Z"
                  fill="white"
                />
                <path
                  d="M11.3102 18.6361C11.3409 18.6422 11.3715 18.6451 11.4017 18.6451C11.5879 18.6451 11.7604 18.5336 11.834 18.3561L16.7669 6.44696C16.8394 6.27207 16.7993 6.07073 16.6654 5.93687C16.5315 5.80301 16.3303 5.76307 16.1553 5.83538L4.24624 10.7684C4.03991 10.8539 3.92274 11.0731 3.96627 11.2921C4.00988 11.5112 4.20201 11.6689 4.42535 11.6689H10.9335V18.1771C10.9335 18.4003 11.0913 18.5925 11.3102 18.6361ZM6.77838 10.7327L15.4696 7.13265L11.8696 15.824V11.2008C11.8696 10.9423 11.66 10.7327 11.4015 10.7327H6.77838Z"
                  fill="white"
                />
              </svg>
              <span class="pl-2">Nearby</span>
            </button>
            <form
              @submit="searchProps"
              class="m-2 filter-search-div ml-auto"
              :class="{ expanded: expand }"
            >
              <input
                v-model="searchField"
                class="filter-search"
                placeholder="Enter your properties or projects here... (Press Enter to Search)"
              />
              <span class="search-icon" @click="expand = !expand">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.98706 11.9735C7.31543 11.9732 8.60551 11.5285 9.65189 10.7103L12.9418 14L14 12.9418L10.7101 9.65213C11.5288 8.60569 11.9738 7.31538 11.9741 5.98674C11.9741 2.6858 9.28818 0 5.98706 0C2.68595 0 0 2.6858 0 5.98674C0 9.28768 2.68595 11.9735 5.98706 11.9735ZM5.98706 1.49669C8.46346 1.49669 10.4774 3.51048 10.4774 5.98674C10.4774 8.46301 8.46346 10.4768 5.98706 10.4768C3.51066 10.4768 1.49677 8.46301 1.49677 5.98674C1.49677 3.51048 3.51066 1.49669 5.98706 1.49669Z"
                    fill="white"
                  />
                </svg>
              </span>
            </form>
            <a
              v-if="current_user"
              href="/users/account?tab=watch_list"
              class="watch-list-link"
            >
              <svg
                width="24"
                height="15"
                viewBox="0 0 24 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.6391 0.64969C20.4018 0.105797 19.7605 -0.146181 19.2067 0.0868805C18.6529 0.319942 18.3963 0.949788 18.6336 1.49368L19.9276 4.45938C19.4862 4.34617 19.023 4.2859 18.5454 4.2859C16.0567 4.2859 13.9572 5.92295 13.3025 8.16047C12.8776 8.05787 12.4404 8.00549 12 8.00549C11.5596 8.00549 11.1223 8.05787 10.6975 8.16045C10.0428 5.92295 7.94333 4.2859 5.45454 4.2859C2.44208 4.2859 0 6.68433 0 9.64295C0 12.6016 2.44208 15 5.45454 15C8.22334 15 10.5103 12.9739 10.8621 10.3489C11.2254 10.2167 11.6109 10.1483 12 10.1483C12.389 10.1483 12.7745 10.2167 13.1378 10.3489C13.4897 12.9739 15.7767 15 18.5454 15C21.5579 15 24 12.6016 24 9.64295L24 9.01163C23.9999 8.57637 23.9096 8.14525 23.7349 7.74522L20.6391 0.64969ZM15.2728 9.66176C15.2831 11.4283 16.7444 12.8572 18.5454 12.8572C20.3529 12.8572 21.8182 11.4181 21.8182 9.64295C21.8182 7.86778 20.3529 6.42872 18.5454 6.42872C16.7439 6.42872 15.2823 7.85835 15.2728 9.62548C15.273 9.63756 15.273 9.64965 15.2728 9.66176ZM5.45454 6.42872C3.64707 6.42872 2.18182 7.86778 2.18182 9.64295C2.18182 11.4181 3.64707 12.8572 5.45454 12.8572C7.25482 12.8572 8.71559 11.4296 8.7272 9.66414C8.72693 9.65044 8.72694 9.63676 8.72721 9.62309C8.71633 7.85706 7.25527 6.42872 5.45454 6.42872Z"
                  fill="#D80000"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.79331 0.0868805C5.3471 0.319942 5.60366 0.949788 5.36636 1.49368L2.27036 8.58963C2.21222 8.72274 2.18198 8.86646 2.18182 9.0113V9.64295C2.18182 10.2347 1.6934 10.7144 1.09091 10.7144C0.488416 10.7144 0 10.2347 0 9.64295V9.01083C0.000335585 8.57611 0.0904566 8.14517 0.264909 7.74564L3.36091 0.649689C3.59821 0.105797 4.23952 -0.146181 4.79331 0.0868805Z"
                  fill="#D80000"
                />
              </svg>
              <span class="count">{{ watch_list_count }}</span>
            </a>
          </div>
        </div>

        <!-- Mobile top filters -->
        <div id="filter-m-top" class="p-2 dn-mb filter-margin">
          <div class="d-flex flex-nowrap align-items-center py-2">
            <div
              class="row justify-content-center"
              style="margin: 0 -5px; flex: auto"
            >
              <label
                class="btn sale-checkbox-label"
                :class="{ active: apiparams.listing_type == 'SALE' }"
              >
                <input
                  name="listingType"
                  type="radio"
                  @click="updateParam('listing_type', $event)"
                  value="SALE"
                />
                Sale
              </label>
              <label
                class="btn sale-checkbox-label"
                :class="{ active: apiparams.listing_type == 'RENT' }"
              >
                <input
                  name="listingType"
                  type="radio"
                  @click="updateParam('listing_type', $event)"
                  value="RENT"
                />
                Rent
              </label>
              <label
                class="btn sale-checkbox-label"
                :class="{ active: apiparams.listing_type == 'AUCTION' }"
              >
                <input
                  name="listingType"
                  type="radio"
                  @click="updateParam('listing_type', $event)"
                  value="AUCTION"
                />
                Auction
              </label>
            </div>
            <button class="filter-dots-m ml-2" @click="openNav()">
              <div
                class="d-flex align-items-center justify-content-center"
                style="
                  background: #000000;
                  color: #ffffff;
                  border-radius: 50%;
                  height: 25px;
                  width: 25px;
                "
              >
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 11 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.18182 8.22222V5.41358M2.18182 3.80864V1M5.33333 8.22222V4.61111M5.33333 3.00617V1M8.48485 8.22222V6.21605M8.48485 4.61111V1M1 5.41358H3.36364M4.15152 3.00617H6.51515M7.30303 6.21605H9.66667"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="pl-1">More</span>
            </button>
          </div>
          <div class="row" style="margin: 0 -2px">
            <label
              class="btn prop-radio-label"
              :class="{ active: apiparams.category == 'RESIDENTIAL' }"
            >
              <input
                type="radio"
                @click="updateParam('category', $event)"
                value="RESIDENTIAL"
              />
              <div>
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.3667 13.5562H10.7334V9.7229H5.3667V13.5562ZM6.13337 12.7896V11.6396H9.9667V12.7896H6.13337ZM9.9667 10.4896V10.8729H6.13337V10.4896H9.9667Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M5.3667 15.0896V19.6896H10.7334V15.0896H5.3667ZM7.6667 15.8563V17.0063H6.13337V15.8563H7.6667ZM6.13337 17.7729H7.6667V18.9229H6.13337V17.7729ZM8.43337 18.9229V17.7729H9.9667V18.9229H8.43337ZM9.9667 17.0063H8.43337V15.8563H9.9667V17.0063Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M12.2666 13.5562H17.6333V9.7229H12.2666V13.5562ZM13.0333 12.7896V12.4062H16.8666V12.7896H13.0333ZM16.8666 10.4896V11.6396H13.0333V10.4896H16.8666Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M22.6167 18.1562C22.4047 18.1562 22.2333 18.3279 22.2333 18.5395V18.9229H21.85V18.5395C21.85 18.3279 21.6786 18.1562 21.4667 18.1562C21.2547 18.1562 21.0833 18.3279 21.0833 18.5395V18.9229H20.7V11.178C20.8997 11.2677 21.1113 11.3172 21.3233 11.3172C21.7346 11.3172 22.1433 11.15 22.4453 10.825C22.7367 10.5114 22.8842 10.087 22.8505 9.66038C22.8164 9.23412 22.6036 8.83813 22.2671 8.5744L12.5434 0.968683L11.5 0L10.4815 0.9476L0.733317 8.5744C0.396367 8.83813 0.183617 9.23412 0.149883 9.66038C0.11615 10.087 0.263733 10.5114 0.555067 10.825C1.01277 11.3179 1.71312 11.4421 2.30038 11.1784V18.9233H1.91667V18.5399C1.91667 18.3283 1.74532 18.1566 1.53333 18.1566C1.32135 18.1566 1.15 18.3283 1.15 18.5399V18.9233H0.766667V18.5399C0.766667 18.3283 0.595317 18.1566 0.383333 18.1566C0.17135 18.1566 0 18.3283 0 18.5399V21.9899C0 22.2015 0.17135 22.3733 0.383333 22.3733C0.595317 22.3733 0.766667 22.2015 0.766667 21.9899V21.6066H1.15V21.9899C1.15 22.2015 1.32135 22.3733 1.53333 22.3733C1.74532 22.3733 1.91667 22.2015 1.91667 21.9899V21.6066H2.3V22.3733H12.2667H17.6333H20.7V21.6066H21.0833V21.9899C21.0833 22.2015 21.2547 22.3733 21.4667 22.3733C21.6786 22.3733 21.85 22.2015 21.85 21.9899V21.6066H22.2333V21.9899C22.2333 22.2015 22.4047 22.3733 22.6167 22.3733C22.8286 22.3733 23 22.2015 23 21.9899V18.5399C23 18.3279 22.8286 18.1562 22.6167 18.1562ZM1.11627 10.3029C0.968683 10.1438 0.897 9.93715 0.91425 9.72095C0.9315 9.50475 1.03462 9.31193 1.20597 9.17815L10.9787 1.53065L11.5004 1.04573L12.0462 1.55135L21.7944 9.17815C21.9654 9.31193 22.0689 9.50475 22.0861 9.72095C22.1034 9.93715 22.0313 10.1442 21.8841 10.3029C21.6127 10.595 21.1707 10.6318 20.8545 10.3883L20.7 10.2695L11.5 3.17783L2.4495 10.1545L2.44912 10.1549L2.1459 10.3883C1.82927 10.6318 1.38767 10.595 1.11627 10.3029ZM0.766667 20.8395V19.6895H1.15V20.8395H0.766667ZM1.91667 20.8395V19.6895H2.3V20.8395H1.91667ZM13.0333 21.6062V15.8562H16.8667V21.6062H13.0333ZM19.9333 21.6062H17.6333V15.0895H12.2667V21.6062H3.06667V10.6463L11.5 4.14537L19.9333 10.6463V21.6062ZM20.7 20.8395V19.6895H21.0833V20.8395H20.7ZM21.85 20.8395V19.6895H22.2333V20.8395H21.85Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </div>
              <div class="pt-2">Residential</div>
            </label>
            <label
              class="btn prop-radio-label"
              :class="{ active: apiparams.category == 'COMMERCIAL' }"
            >
              <input
                type="radio"
                @click="updateParam('category', $event)"
                value="COMMERCIAL"
              />
              <div>
                <svg
                  width="26"
                  height="23"
                  viewBox="0 0 23 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.9429 18.005H21.5596V8.00975C22.4251 7.45285 23 6.48178 23 5.37832C23 5.31969 22.9847 5.26206 22.9556 5.21116L20.2822 0.532639C20.0944 0.204125 19.7427 0 19.3643 0H3.63566C3.25729 0 2.90559 0.20408 2.71782 0.532639L0.0443828 5.21116C0.0153184 5.26206 0 5.31974 0 5.37832C0 6.48178 0.57491 7.45285 1.44037 8.00975V18.005H1.0571C0.871035 18.005 0.720187 18.1558 0.720187 18.3419C0.720187 18.528 0.871035 18.6788 1.0571 18.6788H21.9429C22.129 18.6788 22.2798 18.528 22.2798 18.3419C22.2798 18.1558 22.129 18.005 21.9429 18.005ZM0.697053 5.71523H1.77715C1.96322 5.71523 2.11407 5.56438 2.11407 5.37832C2.11407 5.19225 1.96322 5.0414 1.77715 5.0414H0.917484L3.30288 0.866947C3.37098 0.747814 3.49847 0.673828 3.63566 0.673828H19.3643C19.5015 0.673828 19.6291 0.747814 19.6971 0.866947L22.0825 5.0414H21.2226C21.0365 5.0414 20.8857 5.19225 20.8857 5.37832C20.8857 5.56438 21.0365 5.71523 21.2226 5.71523H22.3029C22.1382 6.90943 21.111 7.83217 19.8723 7.83217C18.6335 7.83217 17.6069 6.90934 17.4421 5.71523H19.7824C19.9685 5.71523 20.1193 5.56438 20.1193 5.37832C20.1193 5.19225 19.9685 5.0414 19.7824 5.0414H3.2178C3.03173 5.0414 2.88088 5.19225 2.88088 5.37832C2.88088 5.56438 3.03173 5.71523 3.2178 5.71523H5.55782C5.39305 6.90934 4.36636 7.83217 3.12769 7.83217C1.88892 7.83217 0.861781 6.90943 0.697053 5.71523ZM16.7209 5.71523C16.5561 6.90934 15.5294 7.83217 14.2908 7.83217C13.0521 7.83217 12.0254 6.90934 11.8606 5.71523H16.7209ZM11.1394 5.71523C10.9746 6.90934 9.9479 7.83217 8.70923 7.83217C7.47055 7.83217 6.44386 6.90934 6.27909 5.71523H11.1394ZM19.0852 18.005H15.4379V16.8784H19.0852V18.005ZM19.0852 16.2045H15.4379V10.0364H19.0852V16.2045ZM20.8858 18.005H19.7591V9.69953C19.7591 9.51346 19.6083 9.36262 19.4222 9.36262H15.101C14.9149 9.36262 14.7641 9.51346 14.7641 9.69953V18.005H2.1142V8.33651C2.43229 8.44581 2.77298 8.506 3.12769 8.506C4.34484 8.506 5.40181 7.8072 5.91846 6.78967C6.4351 7.80715 7.49207 8.506 8.70923 8.506C9.92639 8.506 10.9834 7.8072 11.5 6.78967C12.0166 7.80715 13.0736 8.506 14.2908 8.506C15.5079 8.506 16.5649 7.8072 17.0815 6.78967C17.5982 7.80715 18.6552 8.506 19.8723 8.506C20.227 8.506 20.5677 8.44581 20.8858 8.33656V18.005Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M13.3003 9.36255H3.57764C3.39157 9.36255 3.24072 9.5134 3.24072 9.69946V16.5414C3.24072 16.7274 3.39157 16.8783 3.57764 16.8783H13.3003C13.4865 16.8783 13.6373 16.7274 13.6373 16.5414V9.69946C13.6373 9.51335 13.4865 9.36255 13.3003 9.36255ZM12.9634 16.2045H3.91455V10.0364H12.9634V16.2045Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M17.1938 14.4702V13.4473C16.8748 13.3561 16.6405 13.2186 16.4907 13.0347C16.3426 12.8491 16.2686 12.6245 16.2686 12.3608C16.2686 12.0939 16.3524 11.8701 16.52 11.6895C16.6893 11.5072 16.9139 11.4022 17.1938 11.3745V11.1328H17.5479V11.3745C17.8066 11.4054 18.0125 11.4941 18.1655 11.6406C18.3185 11.7855 18.4162 11.98 18.4585 12.2241L17.8408 12.3047C17.8034 12.1126 17.7057 11.9824 17.5479 11.9141V12.8687C17.9385 12.9744 18.2046 13.112 18.3462 13.2812C18.4878 13.4489 18.5586 13.6646 18.5586 13.9282C18.5586 14.2228 18.4691 14.471 18.29 14.6729C18.1126 14.8747 17.8652 14.9984 17.5479 15.0439V15.5005H17.1938V15.0562C16.9123 15.022 16.6836 14.917 16.5078 14.7412C16.332 14.5654 16.2197 14.3172 16.1709 13.9966L16.8081 13.9282C16.8341 14.0584 16.883 14.1707 16.9546 14.2651C17.0262 14.3595 17.106 14.4279 17.1938 14.4702ZM17.1938 11.9067C17.0978 11.9393 17.0213 11.9946 16.9644 12.0728C16.9074 12.1509 16.8789 12.2371 16.8789 12.3315C16.8789 12.4178 16.9049 12.4984 16.957 12.5732C17.0091 12.6465 17.0881 12.7059 17.1938 12.7515V11.9067ZM17.5479 14.5044C17.6699 14.4816 17.7692 14.4255 17.8457 14.3359C17.9222 14.2448 17.9604 14.1382 17.9604 14.0161C17.9604 13.9071 17.9279 13.8135 17.8628 13.7354C17.7993 13.6556 17.6943 13.5946 17.5479 13.5522V14.5044Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </div>
              <div class="pt-2">Commercial</div>
            </label>
            <label
              class="btn prop-radio-label"
              :class="{ active: apiparams.category == 'INDUSTRIAL' }"
            >
              <input
                type="radio"
                @click="updateParam('category', $event)"
                value="INDUSTRIAL"
              />
              <div>
                <svg
                  width="25"
                  height="23"
                  viewBox="0 0 24 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.90666 16.8784H2.56836V17.5969H9.90666V16.8784Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M12.1008 16.8706H11.3823V19.0722H12.1008V16.8706Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M14.3024 16.8706H13.584V19.0722H14.3024V16.8706Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M16.5036 16.8706H15.7852V19.0722H16.5036V16.8706Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M18.7053 16.8706H17.9868V19.0722H18.7053V16.8706Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M20.9069 16.8706H20.1885V19.0722H20.9069V16.8706Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M23.1085 21.2816V10.4188L17.9407 13.0027L17.2183 0H13.6056L12.8636 11.872L10.5926 13.0075L9.87361 3.30232H6.27523L5.53028 11.8694L0.374584 14.4472V21.2816H0V22H23.4832V21.2816L23.1085 21.2816ZM14.2806 0.718438H16.5387L16.5803 1.4677H14.2338L14.2806 0.718438ZM14.1889 2.18618H16.6202L16.6618 2.93544H14.142L14.1889 2.18618ZM14.0971 3.65383H16.7018L17.2406 13.3527L15.7701 14.088V10.4188L13.6067 11.5004L14.0971 3.65383ZM6.93395 4.02076H9.20645L9.26195 4.77002H6.86882L6.93395 4.02076ZM6.80631 5.48845H9.31511L9.3706 6.23771H6.74113L6.80631 5.48845ZM6.67866 6.95615H9.42385L9.89783 13.3549L8.43155 14.088V10.4188L6.28427 11.4924L6.67866 6.95615ZM2.57613 21.2816H1.09307V20.5323H2.57617V21.2816H2.57613ZM9.18077 21.2816H3.29461V18.6977H9.18077V21.2816ZM22.39 21.2816H9.89925V20.5323H22.39V21.2816ZM22.39 19.8139H9.89925V17.9792H2.57613V19.8139H1.09307V14.8913L7.71307 11.5813V15.2505L15.0516 11.5813V15.2505L22.3901 11.5813V19.8139H22.39Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </div>
              <div class="pt-2">Industrial</div>
            </label>
            <label
              class="btn prop-radio-label"
              :class="{ active: apiparams.category == 'LAND' }"
            >
              <input
                type="radio"
                @click="updateParam('category', $event)"
                value="LAND"
              />
              <div>
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.00725 10.6227C3.1835 10.9422 3.51206 11.1406 3.86473 11.1406H19.1353C19.4879 11.1406 19.8165 10.9422 19.9927 10.6227C20.169 10.3033 20.1691 9.90636 19.9927 9.58692L19.6588 8.98178C19.7946 8.89335 19.9099 8.7703 19.9927 8.62017C20.1691 8.30073 20.1691 7.90381 19.9927 7.58437L19.6588 6.97923C19.7946 6.8908 19.9099 6.76775 19.9927 6.61762C20.1691 6.29818 20.1691 5.90126 19.9927 5.58182L17.1979 0.517901C17.0216 0.19846 16.693 0 16.3404 0C15.9877 0 15.6592 0.19846 15.4829 0.517901L13.9202 3.34932L12.3575 0.517901C12.1812 0.19846 11.8526 0 11.5 0C11.1473 0 10.8188 0.19846 10.6425 0.517901L9.07982 3.34937L7.51712 0.517901C7.34074 0.19846 7.01218 0 6.65959 0C6.30692 0 5.97836 0.19846 5.80211 0.517901L3.00725 5.58182C2.83092 5.90126 2.83092 6.29818 3.00725 6.61767C3.09016 6.76779 3.20537 6.89084 3.34122 6.97923L3.00725 7.58437C2.83092 7.90381 2.83092 8.30073 3.00725 8.62022C3.09016 8.77034 3.20537 8.89339 3.34122 8.98178L3.00725 9.58692C2.83092 9.90636 2.83092 10.3033 3.00725 10.6227V10.6227ZM3.57891 10.2775C3.52011 10.171 3.52011 10.0387 3.57891 9.93219L4.01718 9.13807H8.11289L7.85281 9.57794C7.85105 9.58089 7.84933 9.58388 7.84766 9.58692C7.70191 9.85094 7.677 10.1678 7.77214 10.4501H3.86473C3.74719 10.4501 3.63766 10.3839 3.57891 10.2775V10.2775ZM8.70514 10.4501C8.5876 10.4501 8.47806 10.3839 8.41931 10.2775C8.36122 10.1722 8.36052 10.0418 8.41729 9.93596L8.88905 9.13807H14.111L14.5827 9.93596C14.6395 10.0418 14.6388 10.1722 14.5807 10.2775C14.5219 10.3839 14.4124 10.4501 14.2949 10.4501H8.70514ZM19.4211 10.2775C19.3623 10.3839 19.2528 10.4501 19.1353 10.4501H15.2279C15.323 10.1677 15.298 9.85094 15.1523 9.58692C15.1507 9.58388 15.149 9.58089 15.1472 9.57794L14.8871 9.13807H18.9828L19.4211 9.93219C19.4799 10.0387 19.4799 10.171 19.4211 10.2775V10.2775ZM16.0546 0.863122C16.1133 0.756642 16.2229 0.690535 16.3404 0.690535C16.4579 0.690535 16.5674 0.756734 16.6262 0.863168L19.4211 5.92709C19.4799 6.03357 19.4799 6.16588 19.4211 6.27231C19.3653 6.37336 19.2655 6.43762 19.154 6.44421C19.0395 6.45097 18.9367 6.51938 18.8823 6.62485C18.8278 6.73032 18.8295 6.85779 18.8868 6.96156L19.4211 7.92959C19.4799 8.03607 19.4799 8.16838 19.4211 8.27481C19.3654 8.37586 19.2655 8.44013 19.154 8.44671C19.152 8.44685 19.1501 8.44731 19.148 8.44749H15.2279C15.323 8.16511 15.298 7.84834 15.1523 7.58433L14.8184 6.97919C14.9542 6.89075 15.0695 6.7677 15.1523 6.61758C15.3287 6.29814 15.3287 5.90122 15.1523 5.58178L14.3013 4.03981L16.0546 0.863122ZM11.2142 0.863122C11.2729 0.756688 11.3825 0.690535 11.5 0.690535C11.6175 0.690535 11.727 0.756734 11.7858 0.863168L14.5807 5.92709C14.6395 6.03357 14.6395 6.16588 14.5807 6.27231C14.5249 6.37336 14.4251 6.43762 14.3136 6.44421C14.1991 6.45097 14.0963 6.51938 14.0419 6.62485C13.9874 6.73032 13.9891 6.85779 14.0464 6.96156L14.5807 7.92959C14.6395 8.03607 14.6395 8.16838 14.5807 8.27486C14.5219 8.38134 14.4124 8.44749 14.2949 8.44749H8.70514C8.5876 8.44749 8.47806 8.38134 8.41931 8.27486C8.36052 8.16838 8.36052 8.03607 8.41931 7.92959L8.95361 6.96156C9.0109 6.85774 9.01262 6.73032 8.95818 6.62485C8.90375 6.51938 8.8009 6.45102 8.68648 6.44421C8.57497 6.43758 8.47507 6.37336 8.41936 6.27236C8.36056 6.16588 8.36056 6.03357 8.41936 5.92709L11.2142 0.863122ZM4.11773 6.62485C4.0633 6.51938 3.96045 6.45102 3.84603 6.44421C3.73452 6.43758 3.63462 6.37336 3.57891 6.27236C3.52011 6.16588 3.52011 6.03357 3.57891 5.92709L6.37377 0.863122C6.43252 0.756642 6.54205 0.690535 6.65959 0.690535C6.77714 0.690535 6.88663 0.756734 6.94542 0.863168L8.69867 4.03986L7.84766 5.58182C7.67132 5.90126 7.67132 6.29818 7.84766 6.61767C7.93057 6.76779 8.04578 6.89084 8.18163 6.97923L7.84766 7.58437C7.70191 7.84839 7.677 8.1652 7.77214 8.44754H3.85206C3.85004 8.4474 3.8481 8.4469 3.84608 8.44676C3.73456 8.44013 3.63466 8.37591 3.57895 8.27491C3.52016 8.16843 3.52016 8.03612 3.57895 7.92964L4.11324 6.9616C4.17045 6.85779 4.17217 6.73032 4.11773 6.62485V6.62485Z"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M22.6631 11.5H0.336914C0.150803 11.5 0 11.6514 0 11.8382V22.6618C0 22.8486 0.150803 23 0.336914 23H22.6631C22.8492 23 23 22.8486 23 22.6618V11.8382C23 11.6514 22.8492 11.5 22.6631 11.5ZM22.3262 12.1765V12.8529H0.673828V12.1765H22.3262ZM22.3262 13.5294V19.6176H15.543C14.9857 19.6176 14.5322 19.1624 14.5322 18.6029C14.5322 17.6704 13.7766 16.9118 12.8477 16.9118H0.673828V13.5294H22.3262ZM0.673828 22.3235V21.6471H10.1523C11.0812 21.6471 11.8369 20.8884 11.8369 19.9559C11.8369 19.0233 11.0812 18.2647 10.1523 18.2647C9.96623 18.2647 9.81543 18.4161 9.81543 18.6029C9.81543 18.7898 9.96623 18.9412 10.1523 18.9412C10.7096 18.9412 11.1631 19.3964 11.1631 19.9559C11.1631 20.5154 10.7096 20.9706 10.1523 20.9706H0.673828V18.9412H8.80469C8.9908 18.9412 9.1416 18.7898 9.1416 18.6029C9.1416 18.4161 8.9908 18.2647 8.80469 18.2647H0.673828V17.5882H12.8477C13.405 17.5882 13.8584 18.0435 13.8584 18.6029C13.8584 19.5355 14.6141 20.2941 15.543 20.2941H22.3262V22.3235H0.673828Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </div>
              <div class="pt-2">Land</div>
            </label>
          </div>
        </div>

        <div class="filter-main-row">
          <!-- Mobile location filter -->
          <div id="filter-m-loc" class="loc-margin dn-mf align-items-center">
            <button
              id="details-hotarea-pop"
              class="filter-loc-search"
              style="max-width: 80%"
            >
              <div class="mr-3">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 41 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.8617 18.1987C26.8617 17.3962 26.7054 16.6016 26.4016 15.8601C26.0979 15.1187 25.6527 14.445 25.0915 13.8775C24.5302 13.3101 23.864 12.8599 23.1307 12.5528C22.3974 12.2457 21.6115 12.0876 20.8177 12.0876C20.024 12.0876 19.2381 12.2457 18.5048 12.5528C17.7715 12.8599 17.1053 13.3101 16.544 13.8775C15.9828 14.445 15.5376 15.1187 15.2339 15.8601C14.9301 16.6016 14.7738 17.3962 14.7738 18.1987C14.7738 19.4096 15.1278 20.5358 15.7279 21.4856H15.721C17.7586 24.7114 20.8177 29.5479 20.8177 29.5479L25.9145 21.4856H25.9085C26.5305 20.5047 26.8613 19.364 26.8617 18.1987ZM20.8177 20.8178C20.1308 20.8178 19.4719 20.5419 18.9862 20.0507C18.5004 19.5595 18.2275 18.8934 18.2275 18.1987C18.2275 17.5041 18.5004 16.838 18.9862 16.3468C19.4719 15.8556 20.1308 15.5797 20.8177 15.5797C21.5047 15.5797 22.1636 15.8556 22.6493 16.3468C23.1351 16.838 23.408 17.5041 23.408 18.1987C23.408 18.8934 23.1351 19.5595 22.6493 20.0507C22.1636 20.5419 21.5047 20.8178 20.8177 20.8178Z"
                    fill="white"
                  />
                  <path
                    d="M35.7323 15.232C32.8277 6.83308 23.6315 2.3631 15.2326 5.26772C6.83362 8.17235 2.36364 17.3685 5.26826 25.7675C6.90113 30.489 10.5512 34.1274 15.2827 35.7498C15.6253 35.8672 15.9984 35.6846 16.1159 35.342C16.2335 34.9992 16.0509 34.6262 15.7081 34.5087C11.3613 33.0183 8.00798 29.6759 6.50804 25.3387C3.83986 17.6235 7.946 9.17582 15.6614 6.5076C23.3767 3.83938 31.8243 7.94556 34.4924 15.6608C37.1606 23.3761 33.0545 31.8237 25.3392 34.4919C24.9969 34.6103 24.8153 34.9839 24.9337 35.3262C25.0521 35.6686 25.4257 35.8502 25.768 35.7318C34.167 32.8273 38.637 23.6311 35.7323 15.232Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="text-truncate">
                <span v-if="apiparams.nearby" class="text-capitalize"
                  >Nearby Me</span
                >
                <span
                  v-if="apiparams.state"
                  class="text-capitalize text-nowrap"
                  >{{ apiparams.state.toLowerCase() }}</span
                >
                <span v-if="apiparams.state && apiparams.area">, </span>
                <span
                  v-if="apiparams.area"
                  class="text-capitalize text-nowrap"
                  >{{ apiparams.area.toLowerCase() }}</span
                >
                <span
                  v-if="
                    !apiparams.state && !apiparams.area && !apiparams.nearby
                  "
                  >All Areas</span
                >
              </div>
              <i class="fas fa-caret-down ml-3"></i>
            </button>
            <button id="details-search" class="filter-m-search ml-auto">
              <i class="fas fa-search"></i>
            </button>
          </div>

          <div
            v-if="!apiparams.nearby"
            class="dn-mf position-relative filter-nearby-redbox"
          >
            <div
              class="position-absolute"
              style="left: 15px; top: -20px; z-index: 1"
            >
              <img src="/imgs/location.svg" alt="shijie-location" />
            </div>
            <div
              style="z-index: 1"
              class="w-50 d-flex flex-column justify-content-center ml-auto mr-4 position-relative"
            >
              <div class="filter-explore-text pt-0">
                Discover Properties around you (5 KM)
              </div>
              <button @click="getLocation" class="filter-explore-nearby-btn">
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5 0C5.1589 0 0 5.1589 0 11.5C0 17.8411 5.1589 23 11.5 23C15.0647 23 18.3695 21.3871 20.5669 18.5748C20.726 18.3712 20.6899 18.077 20.4862 17.9179C20.2824 17.7586 19.9883 17.7948 19.8292 17.9985C17.8104 20.5821 14.7745 22.064 11.5 22.064C5.67507 22.064 0.936095 17.325 0.936095 11.5C0.936095 5.675 5.67507 0.936095 11.5 0.936095C17.3249 0.936095 22.0639 5.67507 22.0639 11.5C22.0639 11.7584 22.2735 11.968 22.532 11.968C22.7904 11.968 23 11.7584 23 11.5C23.0001 5.1589 17.8412 0 11.5 0Z"
                    fill="#FD0707"
                  />
                  <path
                    d="M11.3105 18.6361C11.3412 18.6422 11.3718 18.6451 11.402 18.6451C11.5882 18.6451 11.7607 18.5336 11.8343 18.3561L16.7672 6.44696C16.8396 6.27207 16.7995 6.07073 16.6657 5.93687C16.5318 5.80301 16.3306 5.76307 16.1556 5.83538L4.24652 10.7684C4.04019 10.8539 3.92302 11.0731 3.96655 11.2921C4.01016 11.5112 4.20229 11.6689 4.42563 11.6689H10.9338V18.1771C10.9338 18.4003 11.0916 18.5925 11.3105 18.6361ZM6.77865 10.7327L15.4699 7.13265L11.8698 15.824V11.2008C11.8698 10.9423 11.6602 10.7327 11.4018 10.7327H6.77865Z"
                    fill="#FD0707"
                  />
                </svg>
                <span class="ml-2">Explore Nearby</span>
              </button>
            </div>
          </div>

          <!-- Results -->
          <div v-if="isloaded" class="p-2 dn-mf">
            <div
              class="general-text-1 mr-auto"
              style="max-width: 60%"
              v-if="!error"
            >
              <span class="text-capitalize" v-if="searchText">
                {{ searchText.toLowerCase() }}
              </span>
              <span v-if="enteredText">
                Containing
                <span>"{{ enteredText }}"</span>
              </span>
            </div>
            <div v-if="error" class="general-text-1 font-weight-bold">
              No Match Found
            </div>
            <div v-else class="general-text-1 d-flex">
              {{ resultnum }}
              {{ search_mode == "listing" ? "listings" : "transactions" }}
            </div>
          </div>
          <div v-else class="p-2 dn-mb">
            <span class="general-text-1">Searching...</span>
          </div>

          <!-- Properties -->
          <div
            v-if="isloaded"
            id="properties-row"
            class="d-flex flex-wrap px-1 mb-3"
          >
            <template v-for="(row, index) in rows">
              <!-- collections -->
              <div
                v-if="collections.length > 0 && index % 9 == 0 && index != 0"
                :key="'collection-' + index / 9"
                class="desktop-hot-area db-mn"
              >
                <div style="font-size: 24px">
                  Hot Collections Suggested for you
                </div>
                <swiper
                  class="swiper my-4"
                  :options="{
                    slidesPerView: 4,
                    slidesPerColumn: 2,
                    spaceBetween: 12,
                    navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    },
                  }"
                >
                  <swiper-slide
                    v-for="(collection, index) in collections"
                    :key="index"
                  >
                    <a
                      :href="`/collections/${collection.slug}`"
                      class="collection-card"
                    >
                      <div
                        class="image-section"
                        :style="`background-image: url(${collection.featured_photo.thumb.url})`"
                      ></div>
                      <div class="text-section">
                        <div class="title">{{ collection.name }}</div>
                        <div class="listing-count">
                          {{ collection.properties_count }} listings
                        </div>
                      </div>
                    </a>
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
              <div
                v-if="collections.length == 0 && index % 9 == 0 && index != 0"
                :key="'hot-area-' + index / 9"
                class="desktop-hot-area db-mn"
              >
                <div style="font-size: 24px">Hot Areas Suggested for you</div>
                <swiper class="swiper my-4" :options="swiperOption">
                  <swiper-slide v-for="(row, index) in hot_areas" :key="index">
                    <a :href="row.api_url">{{ row.label }}</a>
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
              <div
                v-if="search_mode == 'listing'"
                :class="`p4-propcard ${
                  selected_ids.includes(row.id) ? 'selected' : ''
                }`"
                :key="index"
              >
                <a
                  :href="
                    '/' + apiparams.listing_type.toLowerCase() + '/' + row.slug
                  "
                >
                  <div class="p4-propimg">
                    <img v-lazy="row.featured_photo.medium.url" :alt="row.id" />
                  </div>
                </a>
                <div class="p4-propbody">
                  <a
                    :href="
                      '/' +
                      apiparams.listing_type.toLowerCase() +
                      '/' +
                      row.slug
                    "
                    class="p4-proptitle mb-2"
                  >
                    <span class="text-capitalize">{{
                      row.property_type_name.toLowerCase()
                    }}</span>
                    <span v-if="row.property_type_name && row.project">
                      at
                    </span>
                    <span class="text-capitalize">
                      {{ row.project.toLowerCase() }}</span
                    >
                    <span v-if="row.area && row.project">, </span>
                    <span class="text-capitalize">
                      {{ row.area.toLowerCase() }}</span
                    >
                  </a>
                  <div class="p4-proploc py-1 text-capitalize">
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.4106 7.56055C11.4106 7.16456 11.331 6.77246 11.1763 6.40661C11.0217 6.04077 10.7951 5.70836 10.5093 5.42835C10.2236 5.14835 9.88443 4.92624 9.51112 4.7747C9.13781 4.62316 8.7377 4.54517 8.33364 4.54517C7.92957 4.54517 7.52946 4.62316 7.15615 4.7747C6.78284 4.92624 6.44364 5.14835 6.15792 5.42835C5.8722 5.70836 5.64556 6.04077 5.49093 6.40661C5.3363 6.77246 5.25671 7.16456 5.25671 7.56055C5.25671 8.15803 5.43693 8.71372 5.74243 9.1824H5.73891C6.77627 10.7741 8.33364 13.1606 8.33364 13.1606L10.9284 9.1824H10.9253C11.2419 8.69837 11.4104 8.13552 11.4106 7.56055ZM8.33364 8.85286C7.9839 8.85286 7.64849 8.7167 7.40119 8.47435C7.15389 8.232 7.01496 7.90329 7.01496 7.56055C7.01496 7.21781 7.15389 6.88911 7.40119 6.64675C7.64849 6.4044 7.9839 6.26824 8.33364 6.26824C8.68337 6.26824 9.01878 6.4044 9.26609 6.64675C9.51339 6.88911 9.65232 7.21781 9.65232 7.56055C9.65232 7.90329 9.51339 8.232 9.26609 8.47435C9.01878 8.7167 8.68337 8.85286 8.33364 8.85286Z"
                        fill="#AFAFAF"
                      />
                    </svg>
                    <div style="max-width: calc(100% - 27px)">
                      {{ row.area.toLowerCase() }},
                      {{ row.state.toLowerCase() }}
                    </div>
                  </div>
                  <div class="d-flex flex-nowrap w-100 align-items-center mt-4">
                    <div class="d-flex flex-nowrap align-items-center">
                      <div v-if="row.rent_view_to_offer || row.sale_view_to_offer" class="p4-propprice text-nowrap">
                        Open to offer price
                      </div>
                      <div
                        v-else-if="row.for_sale && apiparams.listing_type == 'SALE'"
                        class="p4-propprice text-nowrap"
                      >
                        RM {{ addComma(row.sale_selling_price) }}
                      </div>
                      <div
                        v-else-if="
                          row.for_rent && apiparams.listing_type == 'RENT'
                        "
                        class="p4-propprice text-nowrap"
                      >
                        RM {{ addComma(row.monthly_rental_price) }}
                      </div>
                      <div
                        v-else-if="
                          row.for_auction && apiparams.listing_type == 'AUCTION'
                        "
                        class="p4-propprice text-nowrap"
                      >
                        RM {{ addComma(row.auction_reserve_price) }}
                      </div>
                    </div>
                    <div class="ml-auto p4-pricepad align-items-center">
                      <div class="dropdown">
                        <a
                          class="btn btn-sm btn-icon-only text-light dropdown-toggle-btn"
                          href="#"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.9282 1.34483C11.9282 1.01631 11.6619 0.75 11.3334 0.75C11.0049 0.75 10.7385 1.01631 10.7385 1.34483V10.4052H1.6782C1.34969 10.4052 1.08337 10.6715 1.08337 11C1.08337 11.3285 1.34969 11.5948 1.6782 11.5948H10.7385V20.6552C10.7385 20.9837 11.0049 21.25 11.3334 21.25C11.6619 21.25 11.9282 20.9837 11.9282 20.6552V11.5948H20.9885C21.3171 11.5948 21.5834 11.3285 21.5834 11C21.5834 10.6715 21.3171 10.4052 20.9885 10.4052H11.9282V1.34483Z"
                              fill="#D80000"
                              stroke="#D80000"
                              stroke-width="0.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                        <div
                          class="dropdown-menu dropdown-menu-right dropdown-menu-arrow"
                        >
                          <label>Actions</label>
                          <ul>
                            <li>
                              <a
                                href="#"
                                @click="updateWatchList($event, index)"
                                ><span class="icon"
                                  ><svg
                                    width="16"
                                    height="10"
                                    viewBox="0 0 16 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M13.7594 0.433126C13.6012 0.0705315 13.1737 -0.097454 12.8045 0.0579203C12.4353 0.213295 12.2642 0.633192 12.4224 0.995787L13.2851 2.97292C12.9908 2.89745 12.682 2.85727 12.3636 2.85727C10.7044 2.85727 9.30478 3.94864 8.8683 5.44031C8.58509 5.37191 8.29358 5.337 7.99998 5.337C7.70638 5.337 7.41488 5.37191 7.13169 5.4403C6.69521 3.94863 5.29555 2.85727 3.63636 2.85727C1.62805 2.85727 0 4.45622 0 6.42863C0 8.40104 1.62805 10 3.63636 10C5.48222 10 7.00686 8.64925 7.24143 6.89928C7.48362 6.81112 7.7406 6.76554 7.99998 6.76554C8.25936 6.76554 8.51636 6.81113 8.75856 6.8993C8.99314 8.64926 10.5178 10 12.3636 10C14.3719 10 16 8.40104 16 6.42863L16 6.00775C15.9999 5.71758 15.9397 5.43016 15.8233 5.16348L13.7594 0.433126ZM10.1818 6.44117C10.1887 7.61885 11.1629 8.57145 12.3636 8.57145C13.5686 8.57145 14.5454 7.61208 14.5454 6.42863C14.5454 5.24519 13.5686 4.28581 12.3636 4.28581C11.1626 4.28581 10.1882 5.2389 10.1818 6.41699C10.182 6.42504 10.182 6.4331 10.1818 6.44117ZM3.63636 4.28581C2.43138 4.28581 1.45454 5.24519 1.45454 6.42863C1.45454 7.61208 2.43138 8.57145 3.63636 8.57145C4.83655 8.57145 5.8104 7.61971 5.81813 6.44276C5.81796 6.43363 5.81796 6.4245 5.81814 6.4154C5.81089 5.23804 4.83685 4.28581 3.63636 4.28581Z"
                                      fill="white"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.19554 0.0579203C3.56473 0.213295 3.73578 0.633192 3.57757 0.995787L1.51357 5.72642C1.47481 5.81516 1.45465 5.91097 1.45454 6.00753V6.42863C1.45454 6.82312 1.12893 7.14292 0.727272 7.14292C0.325611 7.14292 0 6.82312 0 6.42863V6.00722C0.000223723 5.71741 0.0603044 5.43011 0.176606 5.16376L2.2406 0.433126C2.39881 0.0705314 2.82635 -0.097454 3.19554 0.0579203Z"
                                      fill="white"
                                    />
                                  </svg> </span
                                >{{
                                  watch_lists.filter(
                                    (watch_list) =>
                                      watch_list.property_id == row.id
                                  ).length > 0
                                    ? "Remove from"
                                    : "Save to"
                                }}
                                watchlist</a
                              >
                            </li>
                            <li>
                              <span
                                v-if="
                                  isNotAllowToCompare(
                                    row,
                                    apiparams.listing_type
                                  )
                                "
                                class="blocked-action"
                              >
                                <span class="icon">
                                  <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="14"
                                      cy="14"
                                      r="13.75"
                                      fill="#515151"
                                      stroke="#515151"
                                      stroke-width="0.5"
                                    />
                                    <path
                                      d="M14.859 11.6407C14.9294 11.7111 15.0248 11.7507 15.1244 11.7507C15.2239 11.7507 15.3194 11.7111 15.3897 11.6407C15.4601 11.5703 15.4996 11.4748 15.4996 11.3752C15.4996 11.2756 15.4601 11.1801 15.3897 11.1097L14.53 10.2503H15.874C16.371 10.2503 16.8476 10.4478 17.199 10.7994C17.5505 11.151 17.7479 11.6279 17.7479 12.1251V15.4999C17.1845 15.5007 16.642 15.7131 16.2276 16.095C15.8133 16.4769 15.5573 17.0005 15.5103 17.5622C15.4634 18.1239 15.6288 18.6827 15.974 19.1282C16.3192 19.5736 16.819 19.8732 17.3744 19.9677C17.9298 20.0622 18.5004 19.9446 18.9733 19.6383C19.4463 19.332 19.787 18.8592 19.9282 18.3136C20.0694 17.7679 20.0008 17.1891 19.7358 16.6917C19.4709 16.1942 19.0289 15.8144 18.4975 15.6274V12.1251C18.4975 11.429 18.2211 10.7614 17.7291 10.2691C17.2371 9.7769 16.5698 9.50036 15.874 9.50036H14.53L15.3897 8.64092C15.4246 8.60606 15.4522 8.56467 15.4711 8.51912C15.4899 8.47357 15.4996 8.42475 15.4996 8.37544C15.4996 8.32614 15.4899 8.27732 15.4711 8.23177C15.4522 8.18622 15.4246 8.14483 15.3897 8.10996C15.3549 8.0751 15.3135 8.04745 15.268 8.02858C15.2225 8.00971 15.1737 8 15.1244 8C15.0751 8 15.0263 8.00971 14.9808 8.02858C14.9352 8.04745 14.8939 8.0751 14.859 8.10996L13.3599 9.60985C13.325 9.64468 13.2973 9.68606 13.2784 9.73161C13.2595 9.77717 13.2497 9.826 13.2497 9.87533C13.2497 9.92465 13.2595 9.97348 13.2784 10.019C13.2973 10.0646 13.325 10.106 13.3599 10.1408L14.859 11.6407ZM10.2521 12.5001C10.8155 12.4993 11.358 12.2869 11.7724 11.905C12.1867 11.5231 12.4427 10.9995 12.4897 10.4378C12.5366 9.87615 12.3712 9.31728 12.026 8.87183C11.6808 8.42637 11.181 8.12676 10.6256 8.0323C10.0702 7.93783 9.4996 8.05539 9.02667 8.3617C8.55375 8.66802 8.21297 9.14077 8.07177 9.68643C7.93058 10.2321 7.99924 10.8109 8.26419 11.3083C8.52913 11.8058 8.97105 12.1856 9.5025 12.3726V15.8749C9.5025 16.571 9.77891 17.2386 10.2709 17.7309C10.7629 18.2231 11.4302 18.4996 12.126 18.4996H13.47L12.6103 19.3591C12.5399 19.4295 12.5004 19.525 12.5004 19.6246C12.5004 19.7241 12.5399 19.8196 12.6103 19.89C12.6806 19.9604 12.7761 20 12.8756 20C12.9752 20 13.0706 19.9604 13.141 19.89L14.6401 18.3902C14.7098 18.3202 14.7492 18.2257 14.7496 18.1269V18.1224C14.749 18.0239 14.7097 17.9297 14.6401 17.8599L13.141 16.3601C13.0707 16.2897 12.9753 16.2501 12.8759 16.25C12.7764 16.2499 12.681 16.2894 12.6106 16.3597C12.5403 16.43 12.5007 16.5254 12.5006 16.6249C12.5006 16.7244 12.54 16.8199 12.6103 16.8903L13.47 17.7497H12.126C11.629 17.7497 11.1524 17.5522 10.801 17.2006C10.4495 16.849 10.2521 16.3721 10.2521 15.8749V12.5001Z"
                                      fill="white"
                                    />
                                  </svg>
                                </span>
                                <small
                                  >Different category / listing type, not able
                                  to compare
                                </small>
                              </span>
                              <a
                                v-else
                                href="#"
                                @click="
                                  selectToCompare(
                                    row,
                                    apiparams.listing_type,
                                    $event
                                  )
                                "
                              >
                                <span class="icon">
                                  <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="14"
                                      cy="14"
                                      r="13.75"
                                      fill="#515151"
                                      stroke="#515151"
                                      stroke-width="0.5"
                                    />
                                    <path
                                      d="M14.859 11.6407C14.9294 11.7111 15.0248 11.7507 15.1244 11.7507C15.2239 11.7507 15.3194 11.7111 15.3897 11.6407C15.4601 11.5703 15.4996 11.4748 15.4996 11.3752C15.4996 11.2756 15.4601 11.1801 15.3897 11.1097L14.53 10.2503H15.874C16.371 10.2503 16.8476 10.4478 17.199 10.7994C17.5505 11.151 17.7479 11.6279 17.7479 12.1251V15.4999C17.1845 15.5007 16.642 15.7131 16.2276 16.095C15.8133 16.4769 15.5573 17.0005 15.5103 17.5622C15.4634 18.1239 15.6288 18.6827 15.974 19.1282C16.3192 19.5736 16.819 19.8732 17.3744 19.9677C17.9298 20.0622 18.5004 19.9446 18.9733 19.6383C19.4463 19.332 19.787 18.8592 19.9282 18.3136C20.0694 17.7679 20.0008 17.1891 19.7358 16.6917C19.4709 16.1942 19.0289 15.8144 18.4975 15.6274V12.1251C18.4975 11.429 18.2211 10.7614 17.7291 10.2691C17.2371 9.7769 16.5698 9.50036 15.874 9.50036H14.53L15.3897 8.64092C15.4246 8.60606 15.4522 8.56467 15.4711 8.51912C15.4899 8.47357 15.4996 8.42475 15.4996 8.37544C15.4996 8.32614 15.4899 8.27732 15.4711 8.23177C15.4522 8.18622 15.4246 8.14483 15.3897 8.10996C15.3549 8.0751 15.3135 8.04745 15.268 8.02858C15.2225 8.00971 15.1737 8 15.1244 8C15.0751 8 15.0263 8.00971 14.9808 8.02858C14.9352 8.04745 14.8939 8.0751 14.859 8.10996L13.3599 9.60985C13.325 9.64468 13.2973 9.68606 13.2784 9.73161C13.2595 9.77717 13.2497 9.826 13.2497 9.87533C13.2497 9.92465 13.2595 9.97348 13.2784 10.019C13.2973 10.0646 13.325 10.106 13.3599 10.1408L14.859 11.6407ZM10.2521 12.5001C10.8155 12.4993 11.358 12.2869 11.7724 11.905C12.1867 11.5231 12.4427 10.9995 12.4897 10.4378C12.5366 9.87615 12.3712 9.31728 12.026 8.87183C11.6808 8.42637 11.181 8.12676 10.6256 8.0323C10.0702 7.93783 9.4996 8.05539 9.02667 8.3617C8.55375 8.66802 8.21297 9.14077 8.07177 9.68643C7.93058 10.2321 7.99924 10.8109 8.26419 11.3083C8.52913 11.8058 8.97105 12.1856 9.5025 12.3726V15.8749C9.5025 16.571 9.77891 17.2386 10.2709 17.7309C10.7629 18.2231 11.4302 18.4996 12.126 18.4996H13.47L12.6103 19.3591C12.5399 19.4295 12.5004 19.525 12.5004 19.6246C12.5004 19.7241 12.5399 19.8196 12.6103 19.89C12.6806 19.9604 12.7761 20 12.8756 20C12.9752 20 13.0706 19.9604 13.141 19.89L14.6401 18.3902C14.7098 18.3202 14.7492 18.2257 14.7496 18.1269V18.1224C14.749 18.0239 14.7097 17.9297 14.6401 17.8599L13.141 16.3601C13.0707 16.2897 12.9753 16.2501 12.8759 16.25C12.7764 16.2499 12.681 16.2894 12.6106 16.3597C12.5403 16.43 12.5007 16.5254 12.5006 16.6249C12.5006 16.7244 12.54 16.8199 12.6103 16.8903L13.47 17.7497H12.126C11.629 17.7497 11.1524 17.5522 10.801 17.2006C10.4495 16.849 10.2521 16.3721 10.2521 15.8749V12.5001Z"
                                      fill="white"
                                    />
                                  </svg>
                                </span>
                                <span
                                  >{{
                                    selected_ids.includes(row.id)
                                      ? "Un-select"
                                      : "Select"
                                  }}
                                  to compare</span
                                >
                              </a>
                            </li>
                            <li>
                              <a href="#" @click="toggleShare(row.id, $event)">
                                <span class="icon"
                                  ><svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M6.8742 1.56248C6.87416 1.19592 7.003 0.841026 7.23819 0.559875C7.47339 0.278724 7.79995 0.0892234 8.16075 0.0245285C8.52155 -0.0401664 8.89361 0.0240638 9.21183 0.205981C9.53006 0.387899 9.77418 0.67592 9.9015 1.01965C10.0288 1.36338 10.0312 1.74094 9.90827 2.08626C9.78533 2.43158 9.54489 2.72268 9.229 2.90863C8.91311 3.09457 8.5419 3.16352 8.1803 3.10342C7.81871 3.04331 7.48977 2.85798 7.25102 2.57983L3.05286 4.52956C3.14937 4.83542 3.14937 5.16357 3.05286 5.46943L7.25102 7.41916C7.50339 7.12565 7.85573 6.93629 8.23976 6.88776C8.62378 6.83924 9.01215 6.935 9.3296 7.1565C9.64704 7.378 9.87095 7.70946 9.95794 8.08664C10.0449 8.46382 9.98879 8.85987 9.80041 9.19802C9.61203 9.53617 9.30483 9.79235 8.93834 9.9169C8.57184 10.0415 8.17216 10.0255 7.81674 9.87219C7.46133 9.71886 7.17549 9.43904 7.01463 9.08697C6.85377 8.73489 6.82933 8.33564 6.94607 7.96658L2.74791 6.01685C2.54008 6.25905 2.26307 6.43179 1.95413 6.51184C1.64519 6.59188 1.31915 6.57539 1.01986 6.46459C0.720572 6.35378 0.462398 6.15398 0.280069 5.89205C0.0977389 5.63012 0 5.31864 0 4.9995C0 4.68035 0.0977389 4.36887 0.280069 4.10694C0.462398 3.84501 0.720572 3.64521 1.01986 3.5344C1.31915 3.4236 1.64519 3.40711 1.95413 3.48715C2.26307 3.5672 2.54008 3.73994 2.74791 3.98214L6.94607 2.03241C6.89828 1.88035 6.87404 1.72187 6.8742 1.56248Z"
                                      fill="white"
                                    />
                                  </svg>
                                </span>
                                Share
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <share-btn
                        :index="row.id"
                        @remove="hideShare"
                        :manualToggle="share_target"
                        :title="
                          row.property_type_name +
                          ' at ' +
                          row.project +
                          ' ' +
                          row.area +
                          ' for ' +
                          apiparams.listing_type +
                          ' | Shijie Property 世界地產'
                        "
                        :text="
                          'Check out this ' +
                          row.property_type_name +
                          ' for ' +
                          apiparams.listing_type +
                          ' at ' +
                          row.project +
                          '!'
                        "
                        :label="row.project"
                        :url="
                          '/' +
                          apiparams.listing_type.toLowerCase() +
                          '/' +
                          row.slug +
                          webid
                        "
                      ></share-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="search_mode == 'transaction'"
                class="p4-propcard"
                :key="`q${index}`"
              >
                <a>
                  <div class="p4-propimg relative">
                    <span class="recent-transaction"
                      >{{ row.transacted_by_us ? `${row.transaction_type == 'rent' ? 'Rented By Us' : 'Sold by Us' }` : 'Recently Transacted Property'}}</span
                    >
                    <img
                      v-lazy="row.property.featured_photo.medium.url"
                      :alt="row.id"
                    />
                  </div>
                </a>
                <div class="p4-propbody">
                  <div class="p4-proptitle mb-2">
                    <span class="text-capitalize">{{
                      row.property.property_type_name.toLowerCase()
                    }}</span>
                    <span v-if="row.property_type_name && row.project">
                      at
                    </span>
                    <span class="text-capitalize">
                      {{ row.property.project.toLowerCase() }}</span
                    >
                    <span v-if="row.area && row.project">, </span>
                    <span class="text-capitalize">
                      {{ row.property.area.toLowerCase() }}</span
                    >
                  </div>
                  <div class="p4-proploc py-1 text-capitalize">
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.4106 7.56055C11.4106 7.16456 11.331 6.77246 11.1763 6.40661C11.0217 6.04077 10.7951 5.70836 10.5093 5.42835C10.2236 5.14835 9.88443 4.92624 9.51112 4.7747C9.13781 4.62316 8.7377 4.54517 8.33364 4.54517C7.92957 4.54517 7.52946 4.62316 7.15615 4.7747C6.78284 4.92624 6.44364 5.14835 6.15792 5.42835C5.8722 5.70836 5.64556 6.04077 5.49093 6.40661C5.3363 6.77246 5.25671 7.16456 5.25671 7.56055C5.25671 8.15803 5.43693 8.71372 5.74243 9.1824H5.73891C6.77627 10.7741 8.33364 13.1606 8.33364 13.1606L10.9284 9.1824H10.9253C11.2419 8.69837 11.4104 8.13552 11.4106 7.56055ZM8.33364 8.85286C7.9839 8.85286 7.64849 8.7167 7.40119 8.47435C7.15389 8.232 7.01496 7.90329 7.01496 7.56055C7.01496 7.21781 7.15389 6.88911 7.40119 6.64675C7.64849 6.4044 7.9839 6.26824 8.33364 6.26824C8.68337 6.26824 9.01878 6.4044 9.26609 6.64675C9.51339 6.88911 9.65232 7.21781 9.65232 7.56055C9.65232 7.90329 9.51339 8.232 9.26609 8.47435C9.01878 8.7167 8.68337 8.85286 8.33364 8.85286Z"
                        fill="#AFAFAF"
                      />
                    </svg>
                    <div style="max-width: calc(100% - 27px)">
                      {{ row.property.area.toLowerCase() }},
                      {{ row.property.state.toLowerCase() }}
                    </div>
                  </div>
                  <div class="d-flex flex-nowrap w-100 align-items-center mt-4">
                    <div class="d-flex flex-nowrap align-items-center">
                      <div class="p4-propprice text-nowrap">
                        RM {{ addComma(row.transacted_value) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="dn-mf py-5 mx-auto" style="font-size: 10px">
              <infinite-loading @infinite="infiniteHandler">
                <div slot="spinner">
                  <div class="spinner-border text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div slot="no-more">
                  You have reached the bottom of the page
                </div>
                <div slot="no-results">
                  You have reached the bottom of the page
                </div>
              </infinite-loading>
            </div>

            <!-- table pagination -->
            <div
              v-if="resultnum != 0 && isloaded"
              class="df-mn flex-row flex-wrap my-5 px-3 w-100"
              style="font-size: 14px"
            >
              <nav
                v-if="rows.length != 0"
                aria-label="pager"
                role="navigation"
                class="pagy-bootstrap-nav align-self-center"
              >
                <ul class="pagination d-flex flex-wrap justify-content-center">
                  <li class="page-item prev" v-show="pagy.prev">
                    <a
                      @click="changePage(pagy.prev)"
                      aria-label="previous"
                      class="page-link"
                    >
                      <i class="fas fa-arrow-left"></i>
                    </a>
                  </li>
                  <li
                    v-for="index in pagy.series"
                    :key="index"
                    v-show="pagy.series"
                    :class="{ active: index == pagy.page }"
                    class="page-item"
                  >
                    <a
                      v-if="index != 'gap'"
                      @click="changePage(index)"
                      class="page-link"
                      >{{ index }}</a
                    >
                    <div v-else class="page-link">...</div>
                  </li>
                  <li class="page-item next" v-show="pagy.next">
                    <a
                      @click="changePage(pagy.next)"
                      rel="next"
                      aria-label="next"
                      class="page-link"
                    >
                      <i class="fas fa-arrow-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div v-else class="text-center my-5 t-text">
            <div class="spinner-border text-danger" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <!-- No Matched Property -->
          <div
            v-if="error"
            class="d-flex flex-column justify-content-center mx-auto p-5"
          >
            <div class="flex-item justify-content-center mx-auto t-text">
              <i class="fas fa-exclamation-triangle"></i> Sorry we could not
              found what you’ve searched for
            </div>
            <div
              class="flex-item justify-content-center mt-3 mx-auto no-results"
            >
              <svg
                width="100"
                height="150"
                viewBox="0 0 189 198"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M169.105 0H69.6302C58.6582 0 49.7353 8.8803 49.7353 19.8V75.1014L2.91249 121.701C1.52174 123.085 0.574676 124.849 0.191026 126.769C-0.192624 128.689 0.00436646 130.68 0.757093 132.488C1.50982 134.297 2.78448 135.843 4.41995 136.931C6.05541 138.019 7.97824 138.6 9.94536 138.6V188.1C9.94536 190.726 10.9934 193.244 12.8589 195.1C14.7244 196.957 17.2546 198 19.8928 198H179.053C181.691 198 184.221 196.957 186.086 195.1C187.952 193.244 189 190.726 189 188.1V19.8C189 8.8803 180.077 0 169.105 0ZM89.5252 178.2H29.8403V122.899L59.6828 93.1986L89.5252 122.899V178.2ZM169.105 178.2H109.42V138.6C111.389 138.604 113.316 138.026 114.954 136.939C116.593 135.852 117.87 134.305 118.623 132.494C119.377 130.684 119.573 128.691 119.186 126.769C118.8 124.848 117.849 123.083 116.453 121.701L69.6302 75.1014V19.8H169.105V178.2Z"
                />
                <path
                  d="M89.6 39H109.4V59H89.6V39ZM129.2 39H149V59H129.2V39ZM129.2 79.31H149V99H129.2V79.31ZM129.2 119H149V139H129.2V119ZM50 129H69.8V149H50V129Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TRENDING SEARCH -->
    <div id="details-trending" class="p-0 m-0">
      <form
        id="search-props"
        @submit="searchProps"
        class="dn-mf align-items-center justify-content-between filter-div stick-top"
        style="z-index: 3"
      >
        <button type="button" id="details-trend-pop-x" class="popup-back-btn">
          <i class="fas fa-arrow-left"></i>
        </button>
        <input
          class="filter-location-input-m"
          v-model="searchField"
          placeholder="Search your properties or projects here...."
        />
        <button
          type="button"
          id="details-trend-pop-x-2"
          @click="
            apiparams.location = null;
            apiSearch();
          "
          class="popup-back-btn filter-location-x-btn-m"
        >
          ✕
        </button>
      </form>

      <div class="stick-top">
        <div class="filter-div">
          <div class="font-weight-bold general-text-1 pb-3 dn-mb">
            Trending Search
          </div>
          <div class="general-heading-2 db-mn pb-3">Trending Search</div>
          <a
            v-for="(row, index) in suggested"
            :key="index"
            :href="row.api_url"
            class="d-flex align-items-center justify-content-between py-2"
          >
            <div
              class="d-flex align-items-center justify-content-center mr-2"
              style="
                background: #bc1616;
                color: #ffffff;
                border-radius: 50%;
                height: 30px;
                width: 30px;
              "
            >
              <i class="fas fa-search"></i>
            </div>
            <div class="general-text-1 text-truncate w-75">{{ row.label }}</div>
            <div class="px-2"><i class="fas fa-external-link-alt"></i></div>
          </a>
        </div>
        <div class="w-100 text-center mt-5 pb-3">
          <small>You have reached the bottom of the page</small>
        </div>
      </div>
    </div>

    <!-- HOT AREA -->
    <div id="details-hot-area" class="p-0 m-0">
      <div class="stick-top" style="z-index: 3">
        <div
          class="dn-mf align-items-center justify-content-between filter-div m-0"
        >
          <button id="details-hotarea-pop-x" class="popup-back-btn">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="d-flex align-items-center">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0342 11.5408C17.0342 11.0319 16.9351 10.528 16.7425 10.0578C16.5499 9.58759 16.2675 9.16037 15.9116 8.80051C15.5557 8.44065 15.1332 8.15519 14.6682 7.96043C14.2032 7.76568 13.7048 7.66544 13.2014 7.66544C12.6981 7.66544 12.1997 7.76568 11.7347 7.96043C11.2697 8.15519 10.8472 8.44065 10.4913 8.80051C10.1353 9.16037 9.85302 9.58759 9.66041 10.0578C9.46779 10.528 9.36865 11.0319 9.36865 11.5408C9.36865 12.3087 9.59314 13.0229 9.97369 13.6252H9.96931C11.2615 15.6709 13.2014 18.7379 13.2014 18.7379L16.4336 13.6252H16.4297C16.8242 13.0031 17.034 12.2798 17.0342 11.5408ZM13.2014 13.2017C12.7658 13.2017 12.348 13.0267 12.0399 12.7152C11.7319 12.4038 11.5588 11.9813 11.5588 11.5408C11.5588 11.1003 11.7319 10.6779 12.0399 10.3664C12.348 10.0549 12.7658 9.87994 13.2014 9.87994C13.6371 9.87994 14.0549 10.0549 14.363 10.3664C14.671 10.6779 14.8441 11.1003 14.8441 11.5408C14.8441 11.9813 14.671 12.4038 14.363 12.7152C14.0549 13.0267 13.6371 13.2017 13.2014 13.2017Z"
                fill="white"
              />
              <path
                d="M22.6595 9.65945C20.8175 4.33323 14.9857 1.49857 9.65952 3.34055C4.33329 5.18253 1.49863 11.0143 3.34061 16.3405C4.3761 19.3347 6.69082 21.642 9.69129 22.6708C9.9086 22.7453 10.1452 22.6296 10.2197 22.4123C10.2942 22.1949 10.1785 21.9583 9.9611 21.8838C7.20457 20.9387 5.07802 18.8191 4.12682 16.0686C2.43479 11.176 5.03871 5.81888 9.93144 4.12682C14.8242 2.43476 20.1812 5.03871 21.8732 9.93137C23.5653 14.824 20.9614 20.1811 16.0687 21.8732C15.8516 21.9482 15.7364 22.1852 15.8115 22.4023C15.8866 22.6193 16.1235 22.7345 16.3406 22.6594C21.6669 20.8175 24.5015 14.9857 22.6595 9.65945Z"
                fill="white"
              />
            </svg>
            <span class="font-weight-bold ml-2">Location</span>
          </div>
          <button
            id="details-hotarea-pop-x-2"
            @click="resetFilter()"
            class="red-text-btn"
          >
            Reset
          </button>
        </div>
        <div class="dn-mb filter-div">
          <button
            @click="getLocation"
            id="nearby-btn"
            :class="{ active: apiparams.nearby }"
          >
            <div
              class="d-flex align-items-center justify-content-center"
              style="
                background: #000000;
                color: #ffffff;
                border-radius: 50%;
                height: 30px;
                width: 30px;
              "
            >
              <i class="fas fa-crosshairs"></i>
            </div>
            <span class="ml-4"
              ><span v-if="apiparams.nearby">Using</span
              ><span v-else>Use</span> my current location</span
            >
          </button>
          <div class="p-3" style="color: rgba(255, 255, 255, 0.5)">
            Or select the areas you that you want to view
          </div>
          <!-- <div class="row m-0">
                        <div class="col-5 pl-0 pr-2">
                            <select class="filter-location filter-select-icon text-capitalize" v-model="cur_state" id="filter-state">
                                <option style="display:none" value="State">All States</option>
                                <option v-for="option in states" class="text-capitalize" :key="option.index" :value="option">
                                    {{ option.toLowerCase() }}
                                </option>
                            </select>
                        </div>
                        <div class="col-7 pr-0 pl-2">
                            <select class="filter-location filter-select-icon text-capitalize" v-model="cur_area" id="filter-area">
                                <option style="display:none;" value="Area">All Areas</option>
                                <option v-for="option in areas" class="text-capitalize" :key="option.index" :value="option">
                                    {{ option.toLowerCase() }}
                                </option>
                            </select>
                        </div>
                    </div> -->
          <button
            class="filter-location filter-select-icon text-capitalize text-left w-100"
            data-toggle="modal"
            data-target="#area-select"
          >
            <span v-if="apiparams.state" class="text-capitalize">{{
              apiparams.state.toLowerCase()
            }}</span>
            <span v-if="apiparams.state && apiparams.area">, </span>
            <span v-if="apiparams.area" class="text-capitalize">{{
              apiparams.area.toLowerCase()
            }}</span>
            <span v-if="!apiparams.state && !apiparams.area">All Areas</span>
          </button>
        </div>
      </div>

      <div class="filter-div">
        <div class="font-weight-bold general-text-1 pb-3">Hot Area</div>
        <a
          v-for="(row, index) in hot_areas"
          :key="index"
          :href="row.api_url"
          class="dn-mf align-items-center justify-content-between py-2"
        >
          <div
            class="d-flex align-items-center justify-content-center mr-2"
            style="
              background: #bc1616;
              color: #ffffff;
              border-radius: 50%;
              height: 30px;
              width: 30px;
            "
          >
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="general-text-1 text-truncate w-50">{{ row.label }}</div>
          <div class="px-2 d-flex">
            <!-- <div class="mr-2" style="font-size:11px;">115 Listings</div> -->
            <i class="fas fa-external-link-alt"></i>
          </div>
        </a>
      </div>
      <div class="w-100 text-center mt-5 pb-3">
        <small>You have reached the bottom of the page</small>
      </div>
    </div>

    <!-- Area Filter -->
    <div
      class="modal fade"
      id="area-select"
      tabindex="-1"
      role="dialog"
      aria-labelledby="areaSelectModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <transition name="fade" mode="out-in">
          <div key="1" v-if="step == 1" class="modal-content area-modal">
            <button
              data-dismiss="modal"
              @click="
                cur_state = '';
                cur_area = '';
              "
              class="area-modal-btn"
            >
              All States
            </button>
            <button
              v-for="(u, i) in states"
              class="area-modal-btn is-state"
              :key="i"
              @click="cur_state = u"
            >
              {{ u.toLowerCase() }}
              <div
                v-if="!arealoaded && cur_state == u"
                class="spinner-border text-secondary spinner-border-sm ml-3"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <span class="float-right">
                <svg
                  width="9"
                  height="12"
                  viewBox="0 0 9 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 6L4.64275e-07 11.1962L9.18537e-07 0.803847L9 6Z"
                    fill="#C4C4C4"
                  />
                </svg>
              </span>
            </button>
          </div>
          <div key="2" v-if="step == 2" class="modal-content area-modal">
            <button @click="step = 1" class="area-modal-btn">
              &lt; &nbsp; Back
            </button>
            <button
              data-dismiss="modal"
              @click="cur_area = ''"
              class="area-modal-btn"
            >
              All Areas in {{ apiparams.state.toLowerCase() }}
              <span
                class="prop-radio-label-d-before float-right"
                :class="{ lactive: !apiparams.area }"
              ></span>
            </button>
            <button
              data-dismiss="modal"
              v-for="(u, i) in areas"
              class="area-modal-btn"
              :key="i"
              @click="cur_area = u"
            >
              {{ u.toLowerCase() }}
              <span
                class="prop-radio-label-d-before float-right"
                :class="{ lactive: apiparams.area == u }"
              ></span>
            </button>
          </div>
        </transition>
      </div>
    </div>

    <!-- Compare property sticky link -->
    <a
      :href="`/comparisons/new?listing_type=${comparison_listing_type}&category=${comparison_category}&ids[]=${selected_ids.join(
        '&ids[]='
      )}`"
      target="_blank"
      v-if="selected_ids.length > 0"
      class="compare-btn"
    >
      <svg
        data-v-466c094c=""
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          data-v-466c094c=""
          d="M14.859 11.6407C14.9294 11.7111 15.0248 11.7507 15.1244 11.7507C15.2239 11.7507 15.3194 11.7111 15.3897 11.6407C15.4601 11.5703 15.4996 11.4748 15.4996 11.3752C15.4996 11.2756 15.4601 11.1801 15.3897 11.1097L14.53 10.2503H15.874C16.371 10.2503 16.8476 10.4478 17.199 10.7994C17.5505 11.151 17.7479 11.6279 17.7479 12.1251V15.4999C17.1845 15.5007 16.642 15.7131 16.2276 16.095C15.8133 16.4769 15.5573 17.0005 15.5103 17.5622C15.4634 18.1239 15.6288 18.6827 15.974 19.1282C16.3192 19.5736 16.819 19.8732 17.3744 19.9677C17.9298 20.0622 18.5004 19.9446 18.9733 19.6383C19.4463 19.332 19.787 18.8592 19.9282 18.3136C20.0694 17.7679 20.0008 17.1891 19.7358 16.6917C19.4709 16.1942 19.0289 15.8144 18.4975 15.6274V12.1251C18.4975 11.429 18.2211 10.7614 17.7291 10.2691C17.2371 9.7769 16.5698 9.50036 15.874 9.50036H14.53L15.3897 8.64092C15.4246 8.60606 15.4522 8.56467 15.4711 8.51912C15.4899 8.47357 15.4996 8.42475 15.4996 8.37544C15.4996 8.32614 15.4899 8.27732 15.4711 8.23177C15.4522 8.18622 15.4246 8.14483 15.3897 8.10996C15.3549 8.0751 15.3135 8.04745 15.268 8.02858C15.2225 8.00971 15.1737 8 15.1244 8C15.0751 8 15.0263 8.00971 14.9808 8.02858C14.9352 8.04745 14.8939 8.0751 14.859 8.10996L13.3599 9.60985C13.325 9.64468 13.2973 9.68606 13.2784 9.73161C13.2595 9.77717 13.2497 9.826 13.2497 9.87533C13.2497 9.92465 13.2595 9.97348 13.2784 10.019C13.2973 10.0646 13.325 10.106 13.3599 10.1408L14.859 11.6407ZM10.2521 12.5001C10.8155 12.4993 11.358 12.2869 11.7724 11.905C12.1867 11.5231 12.4427 10.9995 12.4897 10.4378C12.5366 9.87615 12.3712 9.31728 12.026 8.87183C11.6808 8.42637 11.181 8.12676 10.6256 8.0323C10.0702 7.93783 9.4996 8.05539 9.02667 8.3617C8.55375 8.66802 8.21297 9.14077 8.07177 9.68643C7.93058 10.2321 7.99924 10.8109 8.26419 11.3083C8.52913 11.8058 8.97105 12.1856 9.5025 12.3726V15.8749C9.5025 16.571 9.77891 17.2386 10.2709 17.7309C10.7629 18.2231 11.4302 18.4996 12.126 18.4996H13.47L12.6103 19.3591C12.5399 19.4295 12.5004 19.525 12.5004 19.6246C12.5004 19.7241 12.5399 19.8196 12.6103 19.89C12.6806 19.9604 12.7761 20 12.8756 20C12.9752 20 13.0706 19.9604 13.141 19.89L14.6401 18.3902C14.7098 18.3202 14.7492 18.2257 14.7496 18.1269V18.1224C14.749 18.0239 14.7097 17.9297 14.6401 17.8599L13.141 16.3601C13.0707 16.2897 12.9753 16.2501 12.8759 16.25C12.7764 16.2499 12.681 16.2894 12.6106 16.3597C12.5403 16.43 12.5007 16.5254 12.5006 16.6249C12.5006 16.7244 12.54 16.8199 12.6103 16.8903L13.47 17.7497H12.126C11.629 17.7497 11.1524 17.5522 10.801 17.2006C10.4495 16.849 10.2521 16.3721 10.2521 15.8749V12.5001Z"
          fill="white"
        ></path></svg
      >Compare <span class="mobile-hide">selected</span> property
      <span class="mobile-hide">({{ selected_ids.length }})</span></a
    >
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import addComponentVue from "../admin/form_template/addComponent.vue";

export default {
  name: "new-filter",
  props: [
    "listing_type",
    "category",
    "properties",
    "ssrpagy",
    "suggested",
    "hot_areas",
    "current_staff",
    "current_user",
  ],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    var wid = "";
    if (this.current_staff) {
      wid = "?marketer=" + this.current_staff.web_id;
    }

    return {
      webid: wid,
      fh: null,
      expand: false,
      isloaded: false,
      error: false,
      SSRender: true,
      rows: this.properties,
      pagy: this.ssrpagy,
      resultnum: this.ssrpagy.count,
      apiparams: {
        listing_type: "",
        category: "",
        location: "",
        state: "",
        area: "",
        max_price: "",
        min_price: "",
        nearby: "",
        property_type_group: "",
        property_type_subtype: [],
      },
      minprice: "",
      maxprice: "",
      curpage: 1,
      locationError: "",
      states: [],
      areas: [],
      searchText: "",
      enteredText: "",
      arealoaded: true,
      step: 1,
      proptype_all: false,
      swiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      collections: [],
      watch_lists: [],
      watch_list_count: 0,
      share_target: "",
      search_mode: "listing",
      selected_ids: [],
      comparison_listing_type: "",
      comparison_category: "",
    };
  },
  computed: {
    apiurl: function () {
      let vm = this;
      var string = "";
      if (vm.apiparams) {
        var entries = Object.entries(vm.apiparams);
        for (const [param, value] of entries) {
          if (param == "listing_type" && value) {
            if (vm.search_mode == "transaction") {
              string = string.concat(
                `?transaction_type=${value.toLowerCase()}`
              );
            } else {
              string = string.concat(`?${param}=${value}`);
            }
          } else if (param == "property_type_subtype") {
            for (var i = 0; i < value.length; i++) {
              string = string.concat(`&${param}[]=${value[i]}`);
            }
          } else if (value) {
            string = string.concat(`&${param}=${value}`);
          }
        }
        if (vm.curpage && vm.curpage != 1) {
          string = string.concat(`&page=${vm.curpage}`);
        }
      }
      return string;
    },
    cur_state: {
      // getter
      get: function () {
        if (this.apiparams.state) {
          return this.apiparams.state;
        } else {
          return "State";
        }
      },
      // setter
      set: function (newValue) {
        this.getAreas(newValue, true);
        //document.getElementById("filter-area").selectedIndex = 0;
        //this.$set(this.apiparams, 'longitude', null);
        //this.$set(this.apiparams, 'latitude', null);
        //this.$set(this.apiparams, 'area', null);
        this.$set(this.apiparams, "state", newValue);
        this.curpage = 1;
        //this.apiSearch();
      },
    },
    cur_area: {
      // getter
      get: function () {
        if (this.apiparams.area) {
          return this.apiparams.area;
        } else {
          return "Area";
        }
      },
      // setter
      set: function (newValue) {
        document.getElementById("details-hot-area").style.display = "none";
        this.$set(this.apiparams, "nearby", null);
        this.$set(this.apiparams, "area", newValue);
        this.curpage = 1;
        this.step = 1;
        this.apiSearch();
      },
    },
    searchField: {
      get: function () {
        return this.apiparams.location;
      },
      set: function (newValue) {
        this.$set(this.apiparams, "location", newValue);
      },
    },
  },
  beforeMount() {
    if (this.current_user) {
      this.getWatchList();
    }
  },
  mounted() {
    document.getElementById("default-listing").innerHTML = "";
    // Checking URL Params
    const urlParams = new URLSearchParams(window.location.search);
    var sraParams = urlParams.get("listing_type") || this.listing_type?.toUpperCase();
    if (!sraParams) {
      sraParams = "RENT";
    }

    this.apiparams = {
      listing_type: sraParams,
      category: urlParams.get("category") || this.category?.toUpperCase(),
      location: urlParams.get("location"),
      state: urlParams.get("state"),
      area: urlParams.get("area"),
      max_price: urlParams.get("max_price"),
      min_price: urlParams.get("min_price"),
      nearby: urlParams.get("nearby"),
      property_type_group: urlParams.get("property_type_group"),
      property_type_subtype: urlParams.getAll("property_type_subtype[]"),
    };
    if (urlParams.get("search_mode")) {
      this.search_mode = urlParams.get("search_mode");
    }
    if (urlParams.get("page")) {
      this.curpage = urlParams.get("page");
    }
    this.getStates();
    if (this.apiparams.state) {
      this.getAreas(this.apiparams.state);
    }

    // If URL Params doesn't exist or equal to rent page 1, render SSR properties
    const entries = Object.entries(this.apiparams);
    for (const [param, value] of entries) {
      if (value && sraParams != "RENT" && this.curpage != 1) {
        this.SSRender = false;
      }
    }
    if (
      this.SSRender &&
      this.rows.length &&
      this.search_mode != "transaction"
    ) {
      this.isloaded = true;
    } else {
      this.apiSearch();
    }

    var textArr = [];
    textArr[0] = "All";
    if (this.apiparams.state) {
      textArr[1] = this.apiparams.state;
    }
    if (this.apiparams.area) {
      textArr[1] = this.apiparams.area;
    }
    if (this.apiparams.nearby) {
      textArr[1] = "Nearby";
    }
    if (this.apiparams.property_type_group) {
      textArr[2] = this.apiparams.property_type_group;
    }
    if (this.apiparams.category) {
      textArr[3] = this.apiparams.category;
    }
    textArr[4] = "Properties";
    if (this.apiparams.listing_type) {
      textArr[5] = "for " + this.apiparams.listing_type.toLowerCase();
    }
    if (this.search_mode == "listing") {
      this.searchText = textArr.join(" ");
    } else {
      this.searchText = `Recent Transaction of ${
        this.listing_type == "RENT"
          ? "Rented"
          : this.listing_type == "SALE"
          ? "Transacted"
          : ""
      }${
        this.apiparams.category ? ` ${this.apiparams.category}` : ""
      } Properties`;
    }
    if (this.apiparams.location) {
      this.enteredText = this.apiparams.location;
    }

    this.fh = document.getElementById("filter-m-top").offsetHeight;

    let vm = this;
    const data_items = this.properties.map((row, i) => {
      const name = `${row.property_type_name?.toLowerCase()} ${
        row.property_type_name && row.project ? "at" : ""
      } ${row.project?.toLowerCase()} ${
        row.area && row.project ? "," : ""
      } ${row.area?.toLowerCase()}`;
      const price =
        row.for_sale && vm.apiparams.listing_type == "SALE"
          ? this.addComma(row.sale_selling_price)
          : row.for_rent && vm.apiparams.listing_type == "RENT"
          ? this.addComma(row.monthly_rental_price)
          : this.addComma(row.auction_reserve_price);
      return {
        item_id: row.id,
        item_name: name,
        price: price,
        item_category: vm.apiparams.listing_type,
        item_category_2: row.category,
        item_list_name: this.searchText ? this.searchText : "Properties list",
      };
    });

    if (dataLayer) {
      dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          items: data_items,
        },
      });
    }

    this.getCollection();
  },
  methods: {
    getWatchList: function (refetch = false) {
      if ($cookies.get("my_watch_lists") && !refetch) {
        this.watch_list_count = $cookies.get("my_watch_lists").length;
        this.watch_lists = $cookies.get("my_watch_lists");
      } else {
        let vm = this;
        this.$http
          .get(`/api/v1/user/watch_lists?scope=all`)
          .then((res) => {
            vm.watch_list_count = res.data.watch_lists.length;
            vm.watch_lists = res.data.watch_lists;
            $cookies.set("my_watch_lists", res.data.watch_lists);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    updateWatchList: function (e, index) {
      e.preventDefault();
      if (this.current_user) {
        let vm = this;
        const watch_list = this.watch_lists.filter(
          (watch_list) => watch_list.property_id == this.rows[index].id
        )?.[0];
        if (watch_list) {
          this.$http
            .delete(`/api/v1/user/watch_lists/${watch_list.id}`)
            .then((res) => {
              vm.$toast.success("Property removed from watchlist successful", {
                position: "top-right",
              });
              vm.getWatchList("refetch");
            })
            .catch((error) => {
              vm.$toast.warning(
                "Property failed remove from watchlist.. Please try again",
                {
                  position: "top-right",
                }
              );
            });
        } else {
          this.$http
            .post("/api/v1/user/watch_lists", {
              watch_list: {
                property_id: this.rows[index].id,
                listing_type: this.apiparams.listing_type,
              },
            })
            .then((res) => {
              vm.$toast.success("Property saved to watchlist successful", {
                position: "top-right",
              });
              vm.getWatchList("refetch");
            })
            .catch((error) => {
              vm.$toast.warning(
                "Property failed save to watchlist.. Please try again",
                {
                  position: "top-right",
                }
              );
            });
        }
      } else {
        this.$modal.show("login-modal");
      }
    },
    toggleShare: function (id, e) {
      if (e) {
        e.preventDefault();
      }
      this.share_target = id;
    },
    hideShare: function () {
      this.share_target = "";
    },
    addComma: function (num) {
      if (num != null) {
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      } else {
        return "";
      }
    },
    apiSearch: function () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      let vm = this;

      setTimeout(() => {
        vm.isloaded = false;
        vm.error = false;
        vm.resultnum = "...";
        vm.searchText = "Loading...";

        if (history.pushState) {
          var root = "";
          var param_url = vm.apiurl;
          if(this.listing_type) {
            root = `/${this.apiparams.listing_type?.toLowerCase()}`
            param_url = param_url.replace(`listing_type=${this.apiparams.listing_type}`, "");
          }
          if(this.category) {
            root += `/${this.apiparams.category?.toLowerCase()}`
            param_url = param_url.replace(`category=${this.apiparams.category}`, "");
          }
          var newurl =
            window.location.protocol +
            "//" +
            window.location.host +
            root +
            param_url +
            (vm.search_mode != "listing" ? "&search_mode=transaction" : "");
          window.history.pushState(
            {
              path: newurl,
            },
            "",
            newurl
          );
        }

        const api =
          vm.search_mode == "listing"
            ? "/listings"
            : "/api/v1/web/property_transactions";
        this.$http
          .get(api + vm.apiurl + "&items=60")
          .then((response) => {
            var textArr = [];
            textArr[0] = "All";
            if (vm.apiparams.state) {
              textArr[1] = vm.apiparams.state;
            }
            if (vm.apiparams.area) {
              textArr[1] = vm.apiparams.area;
            }
            if (vm.apiparams.nearby) {
              textArr[1] = "Nearby";
            }
            if (vm.apiparams.property_type_group) {
              textArr[2] = vm.apiparams.property_type_group;
            }
            if (vm.apiparams.category) {
              textArr[3] = vm.apiparams.category;
            }
            textArr[4] = "Properties";
            if (vm.apiparams.listing_type) {
              textArr[5] = "for " + vm.apiparams.listing_type.toLowerCase();
            }
            if (vm.search_mode == "listing") {
              vm.searchText = textArr.join(" ");
            } else {
              vm.searchText = `Recent Transaction of ${
                vm.listing_type == "RENT"
                  ? "Rented"
                  : vm.listing_type == "SALE"
                  ? "Transacted"
                  : ""
              }${
                vm.apiparams.category ? ` ${vm.apiparams.category}` : ""
              } Properties`;
            }

            if (vm.search_mode == "listing") {
              vm.rows = response.data.data;
              vm.pagy = response.data.pagy;
              vm.resultnum = response.data.pagy.count;
            } else {
              vm.rows = response.data.property_transactions;
              const headers = response.headers;
              const pagy = {
                prev: headers["current-page"] != 1,
                next: headers["current-page"] != headers["total-pages"],
                // series: new Array(parseInt(headers["total-pages"])),
                series: vm.pagination(
                  parseInt(headers["current-page"]),
                  parseInt(headers["total-pages"])
                ),
                page: parseInt(headers["current-page"]),
              };
              vm.pagy = pagy;
              vm.resultnum = headers["total-count"];
            }
            vm.step = 1;
            vm.isloaded = true;

            const data_items = vm.rows.map((row, i) => {
              const name = `${row.property_type_name?.toLowerCase()} ${
                row.property_type_name && row.project ? "at" : ""
              } ${row.project?.toLowerCase()} ${
                row.area && row.project ? "," : ""
              } ${row.area?.toLowerCase()}`;
              const price =
                row.for_sale && vm.apiparams.listing_type == "SALE"
                  ? this.addComma(row.sale_selling_price)
                  : row.for_rent && vm.apiparams.listing_type == "RENT"
                  ? this.addComma(row.monthly_rental_price)
                  : this.addComma(row.auction_reserve_price);
              return {
                item_id: row.id,
                item_name: name,
                price: price,
                item_category: vm.apiparams.listing_type,
                item_category_2: row.category,
                item_list_name: this.searchText
                  ? this.searchText
                  : "Properties list",
              };
            });

            if (dataLayer) {
              dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                  items: data_items,
                },
              });
            }
          })
          .catch((error) => {
            vm.rows = [];
            vm.pagy = [];
            vm.isloaded = true;
            vm.resultnum = 0;
            vm.error = true;
            vm.searchText = "No Match Found.";
            console.log(error);
          });
      }, 100);
    },
    infiniteHandler($state) {
      let vm = this;
      if (vm.pagy.next) {
        vm.curpage = vm.pagy.next;
        const api =
          vm.search_mode == "listing"
            ? "/listings"
            : "/api/v1/web/property_transactions";
        this.$http
          .get(api + vm.apiurl + "&items=60")
          .then((response) => {
            if (vm.search_mode == "listing") {
              vm.rows.push(...response.data.data);
              vm.pagy = response.data.pagy;
              if (vm.pagy.next) {
                $state.loaded();
              } else {
                $state.complete();
              }
            } else {
              vm.rows.push(...response.data.property_transactions);
              const headers = response.headers;
              const pagy = {
                prev: headers["current-page"] != 1,
                next: headers["current-page"] != headers["total-pages"],
                series: new Array(parseInt(headers["total-pages"])),
                page: parseInt(headers["current-page"]),
              };
              vm.pagy = pagy;
              if (pagy.next) {
                $state.loaded();
              } else {
                $state.complete();
              }
            }
          })
          .catch((error) => {
            $state.complete();
          });
      } else {
        $state.complete();
      }
    },
    getCollection() {
      let vm = this;
      this.$http
        .get("/collections.json")
        .then((response) => {
          vm.collections = response.data.collections;
        })
        .catch((error) => {
          vm.collections = [];
          console.log(error);
        });
    },
    getLocation() {
      if ("geolocation" in navigator) {
        if (this.apiparams.nearby) {
          this.$set(this.apiparams, "nearby", null);
          this.apiSearch();
        } else {
          navigator.geolocation.getCurrentPosition(
            this.getLocationSuccess,
            this.getLocationFail
          );
        }
      } else {
        this.locationError = "Your browser not supported this feature.";
      }
    },
    getLocationSuccess(position) {
      this.locationError = "";
      const nearby_base64 = btoa(
        `${position.coords.latitude},${position.coords.longitude}`
      );
      this.$set(this.apiparams, "nearby", nearby_base64);
      this.$set(this.apiparams, "area", null);
      this.$set(this.apiparams, "state", null);
      this.areas = [];
      //document.getElementById("filter-state").selectedIndex = 0;
      //document.getElementById("filter-area").selectedIndex = 0;
      this.apiSearch();
    },
    getLocationFail() {
      this.locationError = "Please allow browser to track your location.";
    },
    getStates: function () {
      let vm = this;
      this.$http
        .get("/streets/states")
        .then((response) => {
          vm.states = response.data.data.sort();
        })
        .catch((error) => {
          vm.states = [];
          console.log(error);
        });
    },
    getAreas: function (state, bool) {
      let vm = this;
      vm.arealoaded = false;
      this.$http
        .get("/streets/areas?state=" + state)
        .then((response) => {
          vm.areas = response.data.data.sort();
          if (bool) {
            vm.step = 2;
          } else {
            vm.step = 1;
          }
          vm.arealoaded = true;
        })
        .catch((error) => {
          vm.areas = [];
          console.log(error);
          vm.arealoaded = true;
        });
    },
    updateParam: function (prop, event) {
      if (prop == "category" && event.target.value == this.apiparams.category) {
        this.$set(this.apiparams, prop, null);
      } else if (prop === "price") {
        this.$set(this.apiparams, "min_price", this.minprice);
        this.$set(this.apiparams, "max_price", this.maxprice);
      } else if (prop === "prop_type_landed") {
        var array = this.apiparams.property_type_subtype || [];
        if (array.includes(event.target.value)) {
          for (var i = 0; i < array.length; i++) {
            if (array[i] == event.target.value) {
              array.splice(i, 1);
            }
          }
        } else {
          array.push(event.target.value);
        }
        if (array.length) {
          this.$set(this.apiparams, "property_type_group", "LANDED");
        } else {
          this.$set(this.apiparams, "property_type_group", null);
        }
        this.$set(this.apiparams, "property_type_subtype", array);
        this.proptype_all = false;
      } else if (prop === "prop_type_highrise") {
        if (this.apiparams.property_type_group == "HIGHRISE") {
          this.$set(this.apiparams, "property_type_group", null);
        } else {
          this.$set(this.apiparams, "property_type_group", "HIGHRISE");
        }
        this.$set(this.apiparams, "property_type_subtype", []);
        this.proptype_all = false;
      } else if (prop === "prop_type_reset") {
        this.$set(this.apiparams, "property_type_group", null);
        this.$set(this.apiparams, "property_type_subtype", []);
        this.proptype_all = true;
      } else if (prop === "search_mode") {
        this.search_mode = event.target.value;
      } else {
        this.$set(this.apiparams, prop, event.target.value);
      }

      if (prop == "category" || prop == "listing_type") {
        this.selected_ids = [];
        this.comparison_category = "";
        this.comparison_listing_type = "";
      }
      this.curpage = 1;
      this.apiSearch();
    },
    openNav: function () {
      document.getElementById("menubar").style.height = "100%";
      document.getElementById("menubar").style.paddingBottom = "80px";
      document.getElementById("show-property").style.bottom = "0";
      //document.getElementById("backtotop").style.display = "none";
    },
    closeNav: function () {
      document.getElementById("menubar").style.height = "0";
      document.getElementById("menubar").style.paddingBottom = "0";
      document.getElementById("show-property").style.bottom = "100vh";
      //setTimeout(function () {
      //    document.getElementById("backtotop").style.display = "block"
      //}, 400);
    },
    changePage(newPage) {
      if (newPage != this.pagy.page) {
        this.curpage = newPage;
        this.apiSearch();
      }
    },
    searchProps: function (e) {
      e.preventDefault();
      this.curpage = 1;
      this.enteredText = this.apiparams.location;
      this.apiSearch();
    },
    resetFilter: function () {
      let vm = this;
      vm.$set(vm.apiparams, "listing_type", "RENT");
      vm.$set(vm.apiparams, "category", null);
      vm.$set(vm.apiparams, "state", null);
      vm.$set(vm.apiparams, "area", null);
      vm.$set(vm.apiparams, "max_price", null);
      vm.$set(vm.apiparams, "min_price", null);
      vm.$set(vm.apiparams, "location", null);
      vm.$set(vm.apiparams, "nearby", null);
      vm.$set(vm.apiparams, "property_type_group", null);
      vm.$set(vm.apiparams, "property_type_subtype", []);
      (vm.enteredText = ""), (vm.curpage = 1);
      vm.apiSearch();
    },
    isNotAllowToCompare: function (row, listing_type) {
      return (
        (this.comparison_category != "" &&
          row.category != this.comparison_category) ||
        (this.comparison_listing_type != "" &&
          this.comparison_listing_type != listing_type)
      );
    },
    selectToCompare: function (row, listing_type, e) {
      e.preventDefault();
      if (!this.isNotAllowToCompare(row, listing_type)) {
        if (this.selected_ids.length == 0) {
          this.comparison_category = row.category;
          this.comparison_listing_type = listing_type;
        }

        if (this.selected_ids.includes(row.id)) {
          this.selected_ids.splice(this.selected_ids.indexOf(row.id), 1);
        } else if (this.selected_ids.length < 4) {
          this.selected_ids.push(row.id);
        } else {
          this.$toast.warning("Maximum 4 properties can be select to compare", {
            position: "top-right",
          });
        }
      }
    },
    pagination(current, total_page) {
      var pagination_length = 5;
      var range = [];

      for (let i = current; i <= total_page; i++) {
        if (range.length < pagination_length) {
          range.push(i);
        } else {
          range.push("...");
          range.push(total_page);
          break;
        }
      }

      return range;
    },
  },
};
</script>

<style scoped lang="scss">
.filter-up {
  top: -200px !important;
}

.loc-up {
  top: -50px !important;
}

.filter-margin {
  top: 72px !important;
}

.loc-margin {
  top: 222px !important;
}

/* ---------------------------------------------- SWIPER NAVIGATIONS ----------------------------------------------------- */
.swiper {
  height: 160px;
  margin-left: auto;
  margin-right: auto;

  .swiper-slide {
    height: 70px;
    border-bottom: 1px solid var(--p4border1, #303030);
    padding: 1rem 0 1.5rem;

    a {
      color: var(--p4text2, #afafaf);
      font-weight: bold;

      &:hover {
        color: var(--p4redsurface1, #d80000);
      }
    }
  }
}

.swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2217%22%20height%3D%228%22%20viewBox%3D%220%200%2017%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M16.3536%204.35355C16.5488%204.15829%2016.5488%203.84171%2016.3536%203.64645L13.1716%200.464466C12.9763%200.269204%2012.6597%200.269204%2012.4645%200.464466C12.2692%200.659728%2012.2692%200.976311%2012.4645%201.17157L15.2929%204L12.4645%206.82843C12.2692%207.02369%2012.2692%207.34027%2012.4645%207.53553C12.6597%207.7308%2012.9763%207.7308%2013.1716%207.53553L16.3536%204.35355ZM0%204.5H16V3.5H0V4.5Z%22%20fill%3D%22%23FF0000%22%2F%3E%0A%3C%2Fsvg%3E") !important;
  right: 0 !important;
}

.swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2217%22%20height%3D%228%22%20viewBox%3D%220%200%2017%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M0.646446%204.35355C0.451185%204.15829%200.451185%203.84171%200.646446%203.64645L3.82843%200.464466C4.02369%200.269204%204.34027%200.269204%204.53553%200.464466C4.7308%200.659728%204.7308%200.976311%204.53553%201.17157L1.70711%204L4.53553%206.82843C4.7308%207.02369%204.7308%207.34027%204.53553%207.53553C4.34027%207.7308%204.02369%207.7308%203.82843%207.53553L0.646446%204.35355ZM17%204.5H1V3.5H17V4.5Z%22%20fill%3D%22%23FF0000%22%2F%3E%0A%3C%2Fsvg%3E") !important;
  left: 0 !important;
}

.swiper-button-next,
.swiper-button-prev {
  color: #ff0000 !important;
  background: white;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  box-shadow: 1px 1px 3px rgba(156, 167, 170, 0.25);
  height: 40px !important;
  width: 40px !important;
  border: none;
  border-radius: 50%;
  top: 45% !important;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  display: none;
}

.swiper-button-disabled {
  display: none !important;
}
.compare-btn {
  position: fixed;
  right: 50px;
  background: #d80100;
  padding: 10px 20px;
  color: #fff !important;
  border-top-left-radius: 5px;
  bottom: 0;
  border-top-right-radius: 5px;
  z-index: 99;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
}
.compare-btn svg {
  display: none;
}
@media screen and (max-width: 600px) {
  .compare-btn {
    padding: 12px;
    bottom: 30px;
    left: 50%;
    right: unset;
    transform: translate(-50%, 0);
    border-radius: 25px;
  }
  .compare-btn .mobile-hide {
    display: none;
  }
  .compare-btn svg {
    display: inline-block;
  }
}
</style>